
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire001c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire001c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1FxTl", function(module, exports) {

$parcel$export(module.exports, "arcade", () => $1373e8fb862fbfa8$export$11e8552c3b8a3d33);
$parcel$export(module.exports, "bindPointer", () => $1373e8fb862fbfa8$export$7e9d9e3ec42ce160);

var $cuPh8 = parcelRequire("cuPh8");
const $1373e8fb862fbfa8$export$11e8552c3b8a3d33 = {
    paused: false,
    muted: (0, $cuPh8.readSaved)('arcade-muted') === 'true',
    get soundEnabled () {
        return !this.muted && !this.paused;
    },
    mount ({ title: title, help: help, active: active, clearInput: clearInput, restart: restart, retryLevel: retryLevel = null, onResume: onResume = ()=>{} }) {
        const canvas = document.querySelector('canvas');
        canvas.tabIndex = 0;
        canvas.setAttribute('aria-label', `${title} playfield. ${help}`);
        canvas.textContent = `${title} needs a browser with canvas support.`;
        const bar = document.createElement('nav');
        bar.className = 'arcade-toolbar';
        bar.setAttribute('aria-label', 'Arcade controls');
        bar.innerHTML = `<a href="../index.html#arcade">\u{2039} Arcade lobby</a>
      <div class="arcade-tools"><button type="button" id="arcade-pause">Pause (P)</button>
      <button type="button" id="arcade-sound" aria-pressed="false">Sound</button>
      <button type="button" id="arcade-fullscreen">Full screen</button>
      <button type="button" id="arcade-help">How to play</button></div>`;
        document.body.prepend(bar);
        const status = document.createElement('div');
        status.className = 'arcade-session';
        status.innerHTML = '<p id="arcade-status"></p><progress id="arcade-progress" max="100" value="0" aria-label="Game progress"></progress>';
        canvas.after(status);
        const dialog = document.createElement('dialog');
        dialog.className = 'arcade-dialog';
        dialog.setAttribute('aria-labelledby', 'arcade-dialog-title');
        dialog.innerHTML = `<h2 id="arcade-dialog-title">Take a breather.</h2>
      <p id="arcade-dialog-copy"></p><p>${help}</p>
      <div class="arcade-dialog-actions"><button type="button" id="arcade-resume">Resume game</button>
      <button type="button" id="arcade-retry" hidden>Retry this level</button>
      <button type="button" id="arcade-restart">Start a new game</button>
      <a href="../index.html#arcade">Back to arcade</a></div>`;
        document.body.append(dialog);
        const pauseButton = bar.querySelector('#arcade-pause');
        const soundButton = bar.querySelector('#arcade-sound');
        const resumeButton = dialog.querySelector('#arcade-resume');
        const restartButton = dialog.querySelector('#arcade-restart');
        const retryButton = dialog.querySelector('#arcade-retry');
        const syncSound = ()=>{
            soundButton.textContent = this.muted ? 'Sound off (M)' : 'Sound on (M)';
            soundButton.setAttribute('aria-pressed', String(this.muted));
            soundButton.setAttribute('aria-label', this.muted ? 'Unmute sound' : 'Mute sound');
        };
        const resume = ()=>{
            dialog.close();
            this.paused = false;
            clearInput();
            onResume();
            pauseButton.textContent = 'Pause (P)';
            canvas.focus({
                preventScroll: true
            });
        };
        const pause = (helpOnly = false)=>{
            if (dialog.open || !active() && !helpOnly) return;
            this.paused = true;
            clearInput();
            document.querySelectorAll('#mobileControls .active').forEach((el)=>el.classList.remove('active'));
            pauseButton.textContent = 'Resume (P)';
            dialog.querySelector('#arcade-dialog-title').textContent = helpOnly ? `${title}: how to play` : 'Take a breather.';
            dialog.querySelector('#arcade-dialog-copy').textContent = active() ? 'Your game is paused. Your score is safe.' : 'Free play. No quarters required.';
            resumeButton.textContent = active() ? 'Resume game' : 'Back to game';
            restartButton.hidden = !active();
            retryButton.hidden = !retryLevel || !active();
            dialog.showModal();
            resumeButton.focus();
        };
        pauseButton.onclick = ()=>this.paused ? resume() : pause();
        bar.querySelector('#arcade-help').onclick = ()=>pause(true);
        resumeButton.onclick = resume;
        dialog.addEventListener('cancel', (e)=>{
            e.preventDefault();
            resume();
        });
        retryButton.onclick = ()=>{
            resume();
            retryLevel?.();
        };
        restartButton.onclick = ()=>{
            resume();
            restart();
            canvas.focus({
                preventScroll: true
            });
        };
        soundButton.onclick = ()=>{
            this.muted = !this.muted;
            (0, $cuPh8.save)('arcade-muted', this.muted);
            syncSound();
            canvas.focus({
                preventScroll: true
            });
        };
        const fullscreen = bar.querySelector('#arcade-fullscreen');
        fullscreen.hidden = !document.fullscreenEnabled;
        fullscreen.onclick = async ()=>{
            try {
                if (document.fullscreenElement) await document.exitFullscreen();
                else await document.documentElement.requestFullscreen();
            } catch  {
                fullscreen.textContent = 'Full screen unavailable';
            }
        };
        document.addEventListener('fullscreenchange', ()=>{
            fullscreen.textContent = document.fullscreenElement ? 'Exit full screen' : 'Full screen';
        });
        // Capture shortcuts before each game's own handlers. Native controls retain Space/Enter.
        document.addEventListener('keydown', (e)=>{
            const control = e.target.closest?.('button, a, input, select, textarea, summary');
            const typing = e.target.closest?.('input, select, textarea');
            if (!typing && !e.ctrlKey && !e.metaKey && !e.altKey) {
                if (e.code === 'KeyP' || e.code === 'Escape') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!e.repeat) this.paused ? resume() : pause();
                    return;
                }
                if (e.code === 'KeyM') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!e.repeat) soundButton.click();
                    return;
                }
            }
            if (this.paused || control) e.stopImmediatePropagation();
        }, true);
        window.addEventListener('blur', ()=>{
            clearInput();
            pause();
        });
        document.addEventListener('visibilitychange', ()=>{
            if (document.hidden) {
                clearInput();
                pause();
            }
        });
        // Move keyboard focus from a start/continue button onto the running game.
        document.getElementById('gameContainer').addEventListener('click', (e)=>{
            if (e.target.closest('button') && active()) canvas.focus({
                preventScroll: true
            });
        });
        syncSound();
        this.status = (text, progress = 0)=>{
            const label = status.querySelector('p');
            if (label.textContent !== text) label.textContent = text;
            status.querySelector('progress').value = Math.max(0, Math.min(100, progress));
            pauseButton.disabled = !active();
        };
    },
    status () {}
};
function $1373e8fb862fbfa8$export$7e9d9e3ec42ce160(button, press, release = ()=>{}) {
    let pointer = null;
    button.addEventListener('pointerdown', (e)=>{
        if ($1373e8fb862fbfa8$export$11e8552c3b8a3d33.paused || pointer !== null || e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault();
        pointer = e.pointerId;
        button.setPointerCapture(pointer);
        button.classList.add('active');
        press();
    });
    const end = (e)=>{
        if (pointer !== e.pointerId) return;
        pointer = null;
        release();
        button.classList.remove('active');
    };
    button.addEventListener('pointerup', end);
    button.addEventListener('pointercancel', end);
    button.addEventListener('lostpointercapture', end);
}

});
parcelRegister("cuPh8", function(module, exports) {

$parcel$export(module.exports, "readSaved", () => $91900f9c9606830c$export$e63c091f2ff08cc);
$parcel$export(module.exports, "save", () => $91900f9c9606830c$export$a1544dad697b423d);
$parcel$export(module.exports, "savedScore", () => $91900f9c9606830c$export$a1a7e8a3422aeb2c);
const $91900f9c9606830c$var$sessionValues = new Map();
function $91900f9c9606830c$export$e63c091f2ff08cc(key, fallback = '') {
    try {
        return localStorage.getItem(key) ?? $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    } catch  {
        return $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    }
}
function $91900f9c9606830c$export$a1544dad697b423d(key, value) {
    $91900f9c9606830c$var$sessionValues.set(key, String(value));
    try {
        localStorage.setItem(key, String(value));
        return true;
    } catch  {
        return false;
    }
}
function $91900f9c9606830c$export$a1a7e8a3422aeb2c(key) {
    const score = Number($91900f9c9606830c$export$e63c091f2ff08cc(key, '0'));
    return Number.isFinite(score) && score > 0 ? Math.floor(score) : 0;
}

});



var $1FxTl = parcelRequire("1FxTl");
"use strict";
/* =====================================================================
       PAPERBOY  —  authentic 1985-style rebuild
       Pure vanilla JS + Canvas 2D, fully self-contained.

       Visual approach: a 3/4 OBLIQUE view. The world is laid out in
       "world" coordinates (a tall vertical strip that scrolls toward the
       camera). When we draw, every world point is run through worldToScreen()
       which applies a horizontal SHEAR based on depth so the lawns / street /
       houses recede diagonally up-and-back like the arcade original.
       Houses are drawn in oblique projection (front face + side face + roof).
       ===================================================================== */ // ----- Canvas / context -------------------------------------------------
const $0dc60fbaf0564b4f$var$canvas = document.getElementById('gameCanvas');
const $0dc60fbaf0564b4f$var$ctx = $0dc60fbaf0564b4f$var$canvas.getContext('2d');
const $0dc60fbaf0564b4f$var$overlay = document.getElementById('overlay');
const $0dc60fbaf0564b4f$var$startButton = document.getElementById('startButton');
const $0dc60fbaf0564b4f$var$GAME_WIDTH = $0dc60fbaf0564b4f$var$canvas.width; // 1000
const $0dc60fbaf0564b4f$var$GAME_HEIGHT = $0dc60fbaf0564b4f$var$canvas.height; // 700
// ----- Reduced motion (live-updating) -----------------------------------
const $0dc60fbaf0564b4f$var$reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
let $0dc60fbaf0564b4f$var$prefersReducedMotion = $0dc60fbaf0564b4f$var$reducedMotionQuery.matches;
$0dc60fbaf0564b4f$var$reducedMotionQuery.addEventListener('change', (e)=>{
    $0dc60fbaf0564b4f$var$prefersReducedMotion = e.matches;
});
const $0dc60fbaf0564b4f$var$DAYS = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
// =====================================================================
//  OBLIQUE PROJECTION
//  World space: x in [0..ROAD_W_TOTAL] across, y = depth (0 = far, grows
//  toward camera). The camera shows a window of depth of height
//  GAME_HEIGHT. We shear x by an amount proportional to how far "back"
//  (small screenY) a point is, producing the receding parallelogram.
// =====================================================================
const $0dc60fbaf0564b4f$var$WORLD_W = 520; // logical width of the playfield strip
const $0dc60fbaf0564b4f$var$SHEAR = 0.42; // how strongly the world slants right as it recedes
const $0dc60fbaf0564b4f$var$WORLD_SCALE_X = $0dc60fbaf0564b4f$var$GAME_WIDTH / $0dc60fbaf0564b4f$var$WORLD_W; // base horizontal scale
// Lane boundaries in WORLD x (left grass | sidewalk | street | sidewalk | right grass)
const $0dc60fbaf0564b4f$var$LEFT_LAWN_X = 0;
const $0dc60fbaf0564b4f$var$LEFT_WALK_X = 110;
const $0dc60fbaf0564b4f$var$STREET_L_X = 150;
const $0dc60fbaf0564b4f$var$STREET_R_X = 370;
const $0dc60fbaf0564b4f$var$RIGHT_WALK_X = 410;
const $0dc60fbaf0564b4f$var$RIGHT_LAWN_X = 520;
// Player rides on the sidewalk band; clamp within these world-x bounds.
const $0dc60fbaf0564b4f$var$PLAYER_MIN_X = 120;
const $0dc60fbaf0564b4f$var$PLAYER_MAX_X = 400;
// Convert a world point (wx across, screenY vertical) to screen coords.
// The amount of horizontal slide depends on screenY: things near the top
// (far away) slide right; the shear pivots around the bottom of screen.
function $0dc60fbaf0564b4f$var$shearAt(screenY) {
    // depth 0 at bottom (screenY=GAME_HEIGHT) -> 1 at top (screenY=0)
    const depth = ($0dc60fbaf0564b4f$var$GAME_HEIGHT - screenY) / $0dc60fbaf0564b4f$var$GAME_HEIGHT;
    return depth * $0dc60fbaf0564b4f$var$SHEAR * $0dc60fbaf0564b4f$var$GAME_WIDTH;
}
function $0dc60fbaf0564b4f$var$worldToScreenX(wx, screenY) {
    return wx * $0dc60fbaf0564b4f$var$WORLD_SCALE_X + $0dc60fbaf0564b4f$var$shearAt(screenY);
}
// =====================================================================
//  PIXEL-SPRITE ENGINE
//  Each sprite = { w, h, palette:{char:color}, rows:[strings...] }
//  '.' = transparent. drawSprite paints integer-aligned rects so it stays
//  crisp and chunky.
// =====================================================================
function $0dc60fbaf0564b4f$var$drawSprite(sprite, ox, oy, scale, flip) {
    const rows = sprite.rows, pal = sprite.palette;
    const s = scale || 1;
    for(let r = 0; r < rows.length; r++){
        const row = rows[r];
        for(let c = 0; c < row.length; c++){
            const ch = row[c];
            if (ch === '.' || ch === ' ') continue;
            const color = pal[ch];
            if (!color) continue;
            $0dc60fbaf0564b4f$var$ctx.fillStyle = color;
            const cx = flip ? sprite.w - 1 - c : c;
            $0dc60fbaf0564b4f$var$ctx.fillRect(Math.round(ox + cx * s), Math.round(oy + r * s), Math.ceil(s), Math.ceil(s));
        }
    }
}
// ---- Tiny pixel font (5x7) for in-canvas text, no web fonts ------------
const $0dc60fbaf0564b4f$var$FONT = {
    'A': [
        "01110",
        "10001",
        "10001",
        "11111",
        "10001",
        "10001",
        "10001"
    ],
    'B': [
        "11110",
        "10001",
        "10001",
        "11110",
        "10001",
        "10001",
        "11110"
    ],
    'C': [
        "01111",
        "10000",
        "10000",
        "10000",
        "10000",
        "10000",
        "01111"
    ],
    'D': [
        "11110",
        "10001",
        "10001",
        "10001",
        "10001",
        "10001",
        "11110"
    ],
    'E': [
        "11111",
        "10000",
        "10000",
        "11110",
        "10000",
        "10000",
        "11111"
    ],
    'F': [
        "11111",
        "10000",
        "10000",
        "11110",
        "10000",
        "10000",
        "10000"
    ],
    'G': [
        "01111",
        "10000",
        "10000",
        "10111",
        "10001",
        "10001",
        "01111"
    ],
    'H': [
        "10001",
        "10001",
        "10001",
        "11111",
        "10001",
        "10001",
        "10001"
    ],
    'I': [
        "11111",
        "00100",
        "00100",
        "00100",
        "00100",
        "00100",
        "11111"
    ],
    'J': [
        "00111",
        "00010",
        "00010",
        "00010",
        "00010",
        "10010",
        "01100"
    ],
    'K': [
        "10001",
        "10010",
        "10100",
        "11000",
        "10100",
        "10010",
        "10001"
    ],
    'L': [
        "10000",
        "10000",
        "10000",
        "10000",
        "10000",
        "10000",
        "11111"
    ],
    'M': [
        "10001",
        "11011",
        "10101",
        "10101",
        "10001",
        "10001",
        "10001"
    ],
    'N': [
        "10001",
        "11001",
        "10101",
        "10011",
        "10001",
        "10001",
        "10001"
    ],
    'O': [
        "01110",
        "10001",
        "10001",
        "10001",
        "10001",
        "10001",
        "01110"
    ],
    'P': [
        "11110",
        "10001",
        "10001",
        "11110",
        "10000",
        "10000",
        "10000"
    ],
    'Q': [
        "01110",
        "10001",
        "10001",
        "10001",
        "10101",
        "10010",
        "01101"
    ],
    'R': [
        "11110",
        "10001",
        "10001",
        "11110",
        "10100",
        "10010",
        "10001"
    ],
    'S': [
        "01111",
        "10000",
        "10000",
        "01110",
        "00001",
        "00001",
        "11110"
    ],
    'T': [
        "11111",
        "00100",
        "00100",
        "00100",
        "00100",
        "00100",
        "00100"
    ],
    'U': [
        "10001",
        "10001",
        "10001",
        "10001",
        "10001",
        "10001",
        "01110"
    ],
    'V': [
        "10001",
        "10001",
        "10001",
        "10001",
        "10001",
        "01010",
        "00100"
    ],
    'W': [
        "10001",
        "10001",
        "10001",
        "10101",
        "10101",
        "11011",
        "10001"
    ],
    'X': [
        "10001",
        "10001",
        "01010",
        "00100",
        "01010",
        "10001",
        "10001"
    ],
    'Y': [
        "10001",
        "10001",
        "01010",
        "00100",
        "00100",
        "00100",
        "00100"
    ],
    'Z': [
        "11111",
        "00010",
        "00100",
        "01000",
        "10000",
        "10000",
        "11111"
    ],
    '0': [
        "01110",
        "10011",
        "10101",
        "10101",
        "11001",
        "10001",
        "01110"
    ],
    '1': [
        "00100",
        "01100",
        "00100",
        "00100",
        "00100",
        "00100",
        "01110"
    ],
    '2': [
        "01110",
        "10001",
        "00001",
        "00110",
        "01000",
        "10000",
        "11111"
    ],
    '3': [
        "11110",
        "00001",
        "00001",
        "01110",
        "00001",
        "00001",
        "11110"
    ],
    '4': [
        "00010",
        "00110",
        "01010",
        "10010",
        "11111",
        "00010",
        "00010"
    ],
    '5': [
        "11111",
        "10000",
        "11110",
        "00001",
        "00001",
        "10001",
        "01110"
    ],
    '6': [
        "01110",
        "10000",
        "10000",
        "11110",
        "10001",
        "10001",
        "01110"
    ],
    '7': [
        "11111",
        "00001",
        "00010",
        "00100",
        "01000",
        "01000",
        "01000"
    ],
    '8': [
        "01110",
        "10001",
        "10001",
        "01110",
        "10001",
        "10001",
        "01110"
    ],
    '9': [
        "01110",
        "10001",
        "10001",
        "01111",
        "00001",
        "00001",
        "01110"
    ],
    ':': [
        "00000",
        "00100",
        "00100",
        "00000",
        "00100",
        "00100",
        "00000"
    ],
    '/': [
        "00001",
        "00010",
        "00010",
        "00100",
        "01000",
        "01000",
        "10000"
    ],
    '!': [
        "00100",
        "00100",
        "00100",
        "00100",
        "00100",
        "00000",
        "00100"
    ],
    '+': [
        "00000",
        "00100",
        "00100",
        "11111",
        "00100",
        "00100",
        "00000"
    ],
    '-': [
        "00000",
        "00000",
        "00000",
        "11111",
        "00000",
        "00000",
        "00000"
    ],
    '.': [
        "00000",
        "00000",
        "00000",
        "00000",
        "00000",
        "00000",
        "00100"
    ],
    ',': [
        "00000",
        "00000",
        "00000",
        "00000",
        "00100",
        "00100",
        "01000"
    ],
    '%': [
        "11001",
        "11010",
        "00100",
        "01000",
        "01011",
        "10011",
        "00000"
    ],
    '?': [
        "01110",
        "10001",
        "00001",
        "00110",
        "00100",
        "00000",
        "00100"
    ],
    '\'': [
        "00100",
        "00100",
        "00100",
        "00000",
        "00000",
        "00000",
        "00000"
    ],
    ' ': [
        "00000",
        "00000",
        "00000",
        "00000",
        "00000",
        "00000",
        "00000"
    ]
};
function $0dc60fbaf0564b4f$var$pixText(str, x, y, size, color) {
    size = size || 2;
    color = color || '#fff';
    $0dc60fbaf0564b4f$var$ctx.fillStyle = color;
    str = String(str).toUpperCase();
    let cx = x;
    for(let i = 0; i < str.length; i++){
        const g = $0dc60fbaf0564b4f$var$FONT[str[i]] || $0dc60fbaf0564b4f$var$FONT['?'];
        for(let r = 0; r < 7; r++){
            for(let c = 0; c < 5; c++)if (g[r][c] === '1') $0dc60fbaf0564b4f$var$ctx.fillRect(cx + c * size, y + r * size, size, size);
        }
        cx += 6 * size;
    }
    return cx; // returns end x
}
function $0dc60fbaf0564b4f$var$pixTextWidth(str, size) {
    return String(str).length * 6 * (size || 2);
}
function $0dc60fbaf0564b4f$var$pixTextCentered(str, cx, y, size, color) {
    $0dc60fbaf0564b4f$var$pixText(str, Math.round(cx - $0dc60fbaf0564b4f$var$pixTextWidth(str, size) / 2), y, size, color);
}
// =====================================================================
//  SPRITE DATA
// =====================================================================
// Player on a BMX bike, oblique/side view, faces right. ~20x18 grid.
// Two pedal frames.
const $0dc60fbaf0564b4f$var$SPR_PLAYER = [
    {
        w: 20,
        h: 20,
        palette: {
            R: '#d23b1f',
            r: '#8c2412',
            S: '#f4c89a',
            H: '#2a2a35',
            h: '#101018',
            B: '#3a6cd0',
            b: '#274a96',
            W: '#f2f2f2',
            T: '#1a1a1a',
            Y: '#ffd23f'
        },
        rows: [
            "..........HHHH......",
            ".........HHHHHH.....",
            ".........HHSSH......",
            "..........SSSS......",
            "....RR....RRR.......",
            "...RRRR..RRRRR......",
            "..RRRRRRRRRRRRR.....",
            "..RRWWRRRRRRRR......",
            "...RWWR..bBBb......",
            "....SS...bBBb.......",
            "....SS....BB........",
            "...TTT....BB........",
            "..TT......SS........",
            ".TT.......SS........",
            "TT........TS........",
            "...................",
            ".TTT.......TTT.....",
            "TTTTT.....TTTTT....",
            "TTbTT.....TTbTT....",
            ".TTT.......TTT....."
        ]
    },
    {
        w: 20,
        h: 20,
        palette: {
            R: '#d23b1f',
            r: '#8c2412',
            S: '#f4c89a',
            H: '#2a2a35',
            h: '#101018',
            B: '#3a6cd0',
            b: '#274a96',
            W: '#f2f2f2',
            T: '#1a1a1a',
            Y: '#ffd23f'
        },
        rows: [
            "..........HHHH......",
            ".........HHHHHH.....",
            ".........HHSSH......",
            "..........SSSS......",
            "....RR....RRR.......",
            "...RRRR..RRRRR......",
            "..RRRRRRRRRRRRR.....",
            "..RRWWRRRRRRRR......",
            "...RWWR..bBBb......",
            ".........bBBb.......",
            "..........BB........",
            "..........BB........",
            ".........SSS........",
            "........SS.SS.......",
            ".......SS...S.......",
            "...................",
            ".TTT.......TTT.....",
            "TTTTT.....TTTTT....",
            "TTbTT.....TTbTT....",
            ".TTT.......TTT....."
        ]
    }
];
// Tumble / wipeout sprite (player crashing).
const $0dc60fbaf0564b4f$var$SPR_PLAYER_CRASH = {
    w: 20,
    h: 20,
    palette: {
        R: '#d23b1f',
        S: '#f4c89a',
        H: '#2a2a35',
        B: '#3a6cd0',
        T: '#1a1a1a',
        Y: '#ffd23f'
    },
    rows: [
        "...................",
        "....Y.....Y........",
        "...Y.HHHH..Y.......",
        "....HHSSHH.........",
        "..RRRRRRRRRR.......",
        ".RRRBBBBBBRRR......",
        "RR.BBBBBBBB.RR.....",
        "S...BBBBBB...S.....",
        "SS..........SS.....",
        ".T...TTTT...T......",
        "TTT.TTTTTT.TTT.....",
        ".T..TTTTTT..T......",
        "....TTTTTT.........",
        "...Y......Y........",
        "..Y........Y.......",
        "...................",
        "...................",
        "...................",
        "...................",
        "..................."
    ]
};
// Dog (chases). 14x10
const $0dc60fbaf0564b4f$var$SPR_DOG = {
    w: 14,
    h: 10,
    palette: {
        B: '#8a5a2b',
        D: '#5d3a18',
        K: '#1a1a1a',
        W: '#fff'
    },
    rows: [
        "..........BBB.",
        ".........BBBBB",
        "..BBBBBBBBBKBB",
        ".BBBBBBBBBBBWB",
        "BBBBBBBBBBBBBB",
        "BBBBBBBBBBBBB.",
        "DD.DD..DD.DD..",
        "DD.DD..DD.DD..",
        "..............",
        ".............."
    ]
};
// Walking person. 10x16
const $0dc60fbaf0564b4f$var$SPR_PERSON = {
    w: 10,
    h: 16,
    palette: {
        S: '#f4c89a',
        H: '#5a3210',
        G: '#2f9e3f',
        P: '#6a4a8a',
        K: '#1a1a1a'
    },
    rows: [
        "...HHHH...",
        "..HHHHHH..",
        "..HSSSSH..",
        "...SSSS...",
        "....SS....",
        "...GGGG...",
        "..GGGGGG..",
        "..GGGGGG..",
        "..GGGGGG..",
        "..GGGGGG..",
        "...PPPP...",
        "...P..P...",
        "...P..P...",
        "...P..P...",
        "..KK..KK..",
        ".KK....KK."
    ]
};
// Breakdancer (spinning on the ground). 14x12
const $0dc60fbaf0564b4f$var$SPR_BREAKER = {
    w: 14,
    h: 12,
    palette: {
        S: '#f4c89a',
        R: '#e23b5f',
        B: '#2244cc',
        K: '#1a1a1a',
        Y: '#ffd23f'
    },
    rows: [
        "......SS......",
        ".....SSSS.....",
        "..K..RRRR..K..",
        ".KK.RRRRRR.KK.",
        "KK.RRRRRRRR.KK",
        "..BBBBBBBBBB..",
        ".BB.BBBBBB.BB.",
        "SS...BBBB...SS",
        ".S...B..B...S.",
        ".....K..K.....",
        "....KK..KK....",
        ".............."
    ]
};
// Skateboarder. 14x14
const $0dc60fbaf0564b4f$var$SPR_SKATER = {
    w: 14,
    h: 14,
    palette: {
        S: '#f4c89a',
        R: '#ff7b39',
        G: '#39c08a',
        K: '#1a1a1a',
        W: '#aaa'
    },
    rows: [
        ".....SSS......",
        "....SSSSS.....",
        "....SRRRS.....",
        ".....RRR......",
        "...RRRRRRR....",
        "..RRRRRRRRR...",
        "...RRRRRRR....",
        "....GG.GG.....",
        "....GG.GG.....",
        "...GG...GG....",
        "..KKK...KKK...",
        ".WWWWWWWWWWWW.",
        "..O........O..",
        ".............."
    ]
};
$0dc60fbaf0564b4f$var$SPR_SKATER.palette.O = '#333';
// Tricycle kid. 14x14
const $0dc60fbaf0564b4f$var$SPR_TRIKE = {
    w: 14,
    h: 14,
    palette: {
        S: '#f4c89a',
        H: '#c23',
        Y: '#ffd23f',
        R: '#e23b1f',
        K: '#1a1a1a'
    },
    rows: [
        "....HHHH......",
        "...HHHHHH.....",
        "...HSSSSH.....",
        "....SSSS......",
        "...YYYYYY.....",
        "..YYYYYYYY....",
        "...YYYYYY.....",
        "....RR.RR.....",
        "...RR...RR....",
        "..KKK...KKK...",
        ".KK.K...K.KK..",
        ".K..K...K..K..",
        "..KK.....KK...",
        ".............."
    ]
};
// Rolling tire. 12x12
const $0dc60fbaf0564b4f$var$SPR_TIRE = {
    w: 12,
    h: 12,
    palette: {
        K: '#1a1a1a',
        G: '#555',
        D: '#333'
    },
    rows: [
        "...KKKKKK...",
        ".KKKDDDDKK..",
        ".KDDGGGGDDK.",
        "KDGGKKKKGGDK",
        "KDGKGGGGKGDK",
        "KDGKGGGGKGDK",
        "KDGKGGGGKGDK",
        "KDGGKKKKGGDK",
        ".KDDGGGGDDK.",
        ".KKKDDDDKK..",
        "...KKKKKK...",
        "............"
    ]
};
// Lawnmower (pushed). 16x12
const $0dc60fbaf0564b4f$var$SPR_MOWER = {
    w: 16,
    h: 12,
    palette: {
        R: '#d22',
        G: '#444',
        K: '#1a1a1a',
        S: '#f4c89a',
        B: '#852'
    },
    rows: [
        "..............BB",
        ".............BB.",
        "............BB..",
        "...........BB...",
        "..RRRRRRRR.B....",
        ".RRRRRRRRRR.....",
        ".RRRRRRRRRR.....",
        ".GGGGGGGGGG.....",
        ".KKK....KKK.....",
        "KKKKK..KKKKK....",
        ".KKK....KKK.....",
        "................"
    ]
};
// Fire hydrant. 8x14
const $0dc60fbaf0564b4f$var$SPR_HYDRANT = {
    w: 8,
    h: 14,
    palette: {
        R: '#d22',
        r: '#911',
        S: '#888'
    },
    rows: [
        "..RRRR..",
        ".RRRRRR.",
        ".RrRRrR.",
        "RRRRRRRR",
        "RRRRRRRR",
        ".RRRRRR.",
        "RRRRRRRR",
        ".RRRRRR.",
        ".RRRRRR.",
        "..RRRR..",
        "..RRRR..",
        ".SSSSSS.",
        "SSSSSSSS",
        "SSSSSSSS"
    ]
};
// Trash can. 10x12
const $0dc60fbaf0564b4f$var$SPR_TRASH = {
    w: 10,
    h: 12,
    palette: {
        G: '#777',
        D: '#555',
        K: '#333'
    },
    rows: [
        ".KKKKKKKK.",
        "KKKKKKKKKK",
        ".DGDGDGDG.",
        ".GDGDGDGD.",
        ".DGDGDGDG.",
        ".GDGDGDGD.",
        ".DGDGDGDG.",
        ".GDGDGDGD.",
        ".DGDGDGDG.",
        ".GDGDGDGD.",
        ".DDDDDDDD.",
        ".KKKKKKKK."
    ]
};
// Paper bundle pickup. 12x10
const $0dc60fbaf0564b4f$var$SPR_BUNDLE = {
    w: 12,
    h: 10,
    palette: {
        W: '#f2f2f2',
        G: '#bbb',
        K: '#222',
        R: '#d22'
    },
    rows: [
        "............",
        ".WWWWWWWWWW.",
        ".WGGGGGGGGW.",
        ".WWWWWWWWWW.",
        ".WRRRRRRRRW.",
        ".WWWWWWWWWW.",
        ".WGGGGGGGGW.",
        ".WWWWWWWWWW.",
        ".KKKKKKKKKK.",
        "............"
    ]
};
// =====================================================================
//  AUDIO (Web Audio chiptune, guarded)
// =====================================================================
let $0dc60fbaf0564b4f$var$audioCtx = null;
function $0dc60fbaf0564b4f$var$initAudio() {
    if ($0dc60fbaf0564b4f$var$audioCtx) return;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (AC) $0dc60fbaf0564b4f$var$audioCtx = new AC();
    } catch (e) {
        $0dc60fbaf0564b4f$var$audioCtx = null;
    }
}
function $0dc60fbaf0564b4f$var$resumeAudio() {
    try {
        if ($0dc60fbaf0564b4f$var$audioCtx && $0dc60fbaf0564b4f$var$audioCtx.state === 'suspended') $0dc60fbaf0564b4f$var$audioCtx.resume();
    } catch (e) {}
}
function $0dc60fbaf0564b4f$var$beep(freq, dur, type, vol, slideTo) {
    if (!$0dc60fbaf0564b4f$var$audioCtx || !(0, $1FxTl.arcade).soundEnabled) return;
    try {
        const t = $0dc60fbaf0564b4f$var$audioCtx.currentTime;
        const osc = $0dc60fbaf0564b4f$var$audioCtx.createOscillator();
        const gain = $0dc60fbaf0564b4f$var$audioCtx.createGain();
        osc.type = type || 'square';
        osc.frequency.setValueAtTime(freq, t);
        if (slideTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t + dur);
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.exponentialRampToValueAtTime(vol || 0.15, t + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        osc.connect(gain);
        gain.connect($0dc60fbaf0564b4f$var$audioCtx.destination);
        osc.start(t);
        osc.stop(t + dur + 0.02);
    } catch (e) {}
}
function $0dc60fbaf0564b4f$var$sfxThrow() {
    $0dc60fbaf0564b4f$var$beep(520, 0.12, 'triangle', 0.12, 240);
}
function $0dc60fbaf0564b4f$var$sfxDeliver() {
    $0dc60fbaf0564b4f$var$beep(660, 0.09, 'square', 0.16);
    setTimeout(()=>$0dc60fbaf0564b4f$var$beep(990, 0.12, 'square', 0.16), 70);
}
function $0dc60fbaf0564b4f$var$sfxPerfect() {
    $0dc60fbaf0564b4f$var$beep(784, 0.08, 'square', 0.16);
    setTimeout(()=>$0dc60fbaf0564b4f$var$beep(988, 0.08, 'square', 0.16), 70);
    setTimeout(()=>$0dc60fbaf0564b4f$var$beep(1318, 0.16, 'square', 0.16), 140);
}
function $0dc60fbaf0564b4f$var$sfxSmash() {
    $0dc60fbaf0564b4f$var$beep(180, 0.18, 'sawtooth', 0.16, 60);
    $0dc60fbaf0564b4f$var$beep(1200, 0.05, 'square', 0.08);
}
function $0dc60fbaf0564b4f$var$sfxCrash() {
    $0dc60fbaf0564b4f$var$beep(140, 0.4, 'sawtooth', 0.2, 40);
}
function $0dc60fbaf0564b4f$var$sfxPickup() {
    $0dc60fbaf0564b4f$var$beep(880, 0.07, 'square', 0.14);
    setTimeout(()=>$0dc60fbaf0564b4f$var$beep(1175, 0.09, 'square', 0.14), 60);
}
function $0dc60fbaf0564b4f$var$sfxBadHit() {
    $0dc60fbaf0564b4f$var$beep(220, 0.22, 'square', 0.16, 110);
}
function $0dc60fbaf0564b4f$var$sfxDayDone() {
    const notes = [
        523,
        659,
        784,
        1047
    ];
    notes.forEach((n, i)=>setTimeout(()=>$0dc60fbaf0564b4f$var$beep(n, 0.16, 'square', 0.16), i * 120));
}
// =====================================================================
//  GAME STATE
// =====================================================================
let $0dc60fbaf0564b4f$var$gameState = 'title'; // title | banner | playing | crashing | dayComplete | gameOver
let $0dc60fbaf0564b4f$var$currentDay = 0;
let $0dc60fbaf0564b4f$var$completedDays = 0;
let $0dc60fbaf0564b4f$var$deliveryStreak = 0;
let $0dc60fbaf0564b4f$var$bestStreak = 0;
let $0dc60fbaf0564b4f$var$score = 0;
let $0dc60fbaf0564b4f$var$lives = 3;
let $0dc60fbaf0564b4f$var$papers = 10;
let $0dc60fbaf0564b4f$var$subscribers = 5; // current live subscriber count (persists across days)
let $0dc60fbaf0564b4f$var$highScore = 0;
// per-day bookkeeping
let $0dc60fbaf0564b4f$var$daySubsTotal = 0; // subscriber houses this day
let $0dc60fbaf0564b4f$var$dayDelivered = 0; // successful subscriber deliveries this day
let $0dc60fbaf0564b4f$var$dayWindowsSmashed = 0; // non-subscriber windows broken
let $0dc60fbaf0564b4f$var$dayPerfectThrows = 0;
let $0dc60fbaf0564b4f$var$houses = [];
let $0dc60fbaf0564b4f$var$entities = []; // obstacles / hazards
let $0dc60fbaf0564b4f$var$bundles = []; // paper bundle pickups
let $0dc60fbaf0564b4f$var$flyingPapers = [];
let $0dc60fbaf0564b4f$var$particles = [];
let $0dc60fbaf0564b4f$var$worldScroll = 0; // how far the world has scrolled toward us
let $0dc60fbaf0564b4f$var$streetLength = 0; // depth at which the houses end
let $0dc60fbaf0564b4f$var$bannerTimer = 0;
let $0dc60fbaf0564b4f$var$crashTimer = 0;
let $0dc60fbaf0564b4f$var$pedalFrame = 0;
let $0dc60fbaf0564b4f$var$pedalAcc = 0;
let $0dc60fbaf0564b4f$var$messageTimer = 0;
let $0dc60fbaf0564b4f$var$messageText = '';
const $0dc60fbaf0564b4f$var$SPEED_MIN = 1.4;
const $0dc60fbaf0564b4f$var$SPEED_MAX = 6.5;
// Player. x is WORLD x; depthY is fixed near bottom of screen.
const $0dc60fbaf0564b4f$var$player = {
    x: 130,
    targetLean: 0,
    lean: 0,
    speed: 3,
    screenY: $0dc60fbaf0564b4f$var$GAME_HEIGHT - 120,
    invincible: false,
    invTimer: 0
};
const $0dc60fbaf0564b4f$var$keys = {};
// ---- High score persistence -------------------------------------------
try {
    const hs = localStorage.getItem('paperboyHighScore');
    if (hs) $0dc60fbaf0564b4f$var$highScore = parseInt(hs, 10) || 0;
} catch (e) {}
function $0dc60fbaf0564b4f$var$saveHighScore() {
    if ($0dc60fbaf0564b4f$var$score > $0dc60fbaf0564b4f$var$highScore) {
        $0dc60fbaf0564b4f$var$highScore = $0dc60fbaf0564b4f$var$score;
        try {
            localStorage.setItem('paperboyHighScore', String($0dc60fbaf0564b4f$var$highScore));
        } catch (e) {}
    }
}
// =====================================================================
//  LEVEL GENERATION
// =====================================================================
const $0dc60fbaf0564b4f$var$HOUSE_PALETTES = [
    {
        wall: '#e86a6a',
        wall2: '#c44',
        roof: '#7a3b2a',
        door: '#5a3210'
    },
    {
        wall: '#6aa0e8',
        wall2: '#4a7ec4',
        roof: '#33506a',
        door: '#5a3210'
    },
    {
        wall: '#e8c46a',
        wall2: '#c4a044',
        roof: '#8a6a2a',
        door: '#5a3210'
    },
    {
        wall: '#8ad06a',
        wall2: '#6aa84a',
        roof: '#3b6a2a',
        door: '#5a3210'
    },
    {
        wall: '#d08ad0',
        wall2: '#a86aa8',
        roof: '#6a3b6a',
        door: '#5a3210'
    },
    {
        wall: '#e8e0d0',
        wall2: '#c4b8a0',
        roof: '#888',
        door: '#5a3210'
    }
];
function $0dc60fbaf0564b4f$var$generateLevel() {
    $0dc60fbaf0564b4f$var$houses = [];
    $0dc60fbaf0564b4f$var$entities = [];
    $0dc60fbaf0564b4f$var$bundles = [];
    $0dc60fbaf0564b4f$var$flyingPapers = [];
    $0dc60fbaf0564b4f$var$particles = [];
    $0dc60fbaf0564b4f$var$worldScroll = 0;
    $0dc60fbaf0564b4f$var$deliveryStreak = 0;
    const diff = $0dc60fbaf0564b4f$var$currentDay; // 0..6
    const houseCount = 7 + Math.min($0dc60fbaf0564b4f$var$currentDay, 4); // 7..11 houses per side
    const spacing = 320; // world depth between houses
    const startDepth = 360;
    // Decide which houses are subscribers. We must guarantee at least
    // `subscribers` subscriber houses exist (so the player can keep them
    // all) and ideally a couple spare non-subscribers to smash.
    // Build a flat list of slots then mark subscribers.
    const slots = [];
    for(let i = 0; i < houseCount; i++){
        slots.push({
            side: 'left',
            depth: startDepth + i * spacing
        });
        slots.push({
            side: 'right',
            depth: startDepth + i * spacing + spacing * 0.5
        });
    }
    // Mark `subscribers` of them as subscribers (spread out), rest are not.
    const subsNeeded = Math.min($0dc60fbaf0564b4f$var$subscribers, slots.length);
    // pick evenly spaced indices for subscribers so they're distributed
    const idxs = [];
    for(let i = 0; i < slots.length; i++)idxs.push(i);
    // shuffle deterministically-ish
    for(let i = idxs.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const t = idxs[i];
        idxs[i] = idxs[j];
        idxs[j] = t;
    }
    const subSet = new Set(idxs.slice(0, subsNeeded));
    slots.forEach((slot, i)=>{
        const isSub = subSet.has(i);
        const pal = $0dc60fbaf0564b4f$var$HOUSE_PALETTES[Math.floor(Math.random() * $0dc60fbaf0564b4f$var$HOUSE_PALETTES.length)];
        // World-x of the house front: out on the lawns beyond the sidewalk.
        const wx = slot.side === 'left' ? 40 : 440;
        $0dc60fbaf0564b4f$var$houses.push({
            side: slot.side,
            wx: wx,
            depth: slot.depth,
            width: 70,
            pal: pal,
            isSubscriber: isSub,
            delivered: false,
            missedHandled: false,
            // non-subscriber windows: 2 panes, can be smashed
            window1: false,
            window2: false,
            subWindowHit: false,
            flash: 0
        });
    });
    $0dc60fbaf0564b4f$var$streetLength = startDepth + houseCount * spacing + 260;
    $0dc60fbaf0564b4f$var$daySubsTotal = $0dc60fbaf0564b4f$var$houses.filter((h)=>h.isSubscriber).length;
    $0dc60fbaf0564b4f$var$dayDelivered = 0;
    $0dc60fbaf0564b4f$var$dayWindowsSmashed = 0;
    $0dc60fbaf0564b4f$var$dayPerfectThrows = 0;
    // -------- Obstacles / hazards --------
    // Variety grows with the day. Each entity has a world depth & x.
    const hazardTypes = [
        'hydrant',
        'trash',
        'tire',
        'dog',
        'person',
        'skater',
        'car',
        'breaker',
        'trike',
        'mower'
    ];
    const baseCount = 10 + diff * 4;
    for(let i = 0; i < baseCount; i++){
        // spread along the street depth, after a small safe zone
        const depth = 260 + Math.random() * ($0dc60fbaf0564b4f$var$streetLength - 360);
        // choose a type weighted by day (later days unlock more dynamic ones)
        let pool;
        if (diff <= 1) pool = [
            'hydrant',
            'trash',
            'tire',
            'dog',
            'person',
            'car'
        ];
        else if (diff <= 3) pool = [
            'hydrant',
            'trash',
            'tire',
            'dog',
            'person',
            'car',
            'skater',
            'trike'
        ];
        else pool = hazardTypes;
        const type = pool[Math.floor(Math.random() * pool.length)];
        $0dc60fbaf0564b4f$var$entities.push($0dc60fbaf0564b4f$var$makeEntity(type, depth));
    }
    // -------- Paper bundles (refills) --------
    const bundleCount = Math.max(2, 5 - Math.floor(diff / 2)); // scarcer later
    for(let i = 0; i < bundleCount; i++){
        const depth = 320 + Math.random() * ($0dc60fbaf0564b4f$var$streetLength - 500);
        // place on the street so they're grab-able
        const wx = $0dc60fbaf0564b4f$var$STREET_L_X + 30 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 60);
        $0dc60fbaf0564b4f$var$bundles.push({
            wx: wx,
            depth: depth,
            collected: false
        });
    }
}
function $0dc60fbaf0564b4f$var$makeEntity(type, depth) {
    // Default placement on the street; some live on the sidewalk.
    let wx = $0dc60fbaf0564b4f$var$STREET_L_X + 20 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 40);
    let vx = 0, vd = 0, moving = false, chase = false, sprite = null, w = 12, h = 12;
    switch(type){
        case 'car':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 30 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 60);
            vd = (Math.random() < 0.5 ? 1 : -1) * (0.6 + $0dc60fbaf0564b4f$var$currentDay * 0.12); // moves along depth
            moving = true;
            w = 34;
            h = 26;
            break;
        case 'dog':
            wx = Math.random() < 0.5 ? $0dc60fbaf0564b4f$var$STREET_L_X + 20 : $0dc60fbaf0564b4f$var$STREET_R_X - 20;
            moving = true;
            chase = true;
            w = 14;
            h = 10;
            sprite = $0dc60fbaf0564b4f$var$SPR_DOG;
            break;
        case 'person':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 20 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 40);
            vx = (Math.random() < 0.5 ? 1 : -1) * 0.4;
            moving = true;
            w = 10;
            h = 16;
            sprite = $0dc60fbaf0564b4f$var$SPR_PERSON;
            break;
        case 'skater':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 20 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 40);
            vx = (Math.random() < 0.5 ? 1 : -1) * 1.1;
            moving = true;
            w = 14;
            h = 14;
            sprite = $0dc60fbaf0564b4f$var$SPR_SKATER;
            break;
        case 'breaker':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 30 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 60);
            w = 14;
            h = 12;
            sprite = $0dc60fbaf0564b4f$var$SPR_BREAKER;
            break;
        case 'trike':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 20 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 40);
            vx = (Math.random() < 0.5 ? 1 : -1) * 0.7;
            moving = true;
            w = 14;
            h = 14;
            sprite = $0dc60fbaf0564b4f$var$SPR_TRIKE;
            break;
        case 'tire':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 20 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 40);
            vx = (Math.random() < 0.5 ? 1 : -1) * 0.9;
            moving = true;
            w = 12;
            h = 12;
            sprite = $0dc60fbaf0564b4f$var$SPR_TIRE;
            break;
        case 'mower':
            wx = Math.random() < 0.5 ? $0dc60fbaf0564b4f$var$STREET_L_X + 10 : $0dc60fbaf0564b4f$var$STREET_R_X - 26;
            vx = (Math.random() < 0.5 ? 1 : -1) * 0.5;
            moving = true;
            w = 16;
            h = 12;
            sprite = $0dc60fbaf0564b4f$var$SPR_MOWER;
            break;
        case 'hydrant':
            wx = Math.random() < 0.5 ? $0dc60fbaf0564b4f$var$STREET_L_X - 6 : $0dc60fbaf0564b4f$var$STREET_R_X + 4;
            w = 8;
            h = 14;
            sprite = $0dc60fbaf0564b4f$var$SPR_HYDRANT;
            break;
        case 'trash':
            wx = $0dc60fbaf0564b4f$var$STREET_L_X + 10 + Math.random() * ($0dc60fbaf0564b4f$var$STREET_R_X - $0dc60fbaf0564b4f$var$STREET_L_X - 20);
            w = 10;
            h = 12;
            sprite = $0dc60fbaf0564b4f$var$SPR_TRASH;
            break;
        default:
            w = 10;
            h = 12;
            sprite = $0dc60fbaf0564b4f$var$SPR_TRASH;
            break;
    }
    return {
        type: type,
        wx: wx,
        depth: depth,
        vx: vx,
        vd: vd,
        moving: moving,
        chase: chase,
        sprite: sprite,
        w: w,
        h: h,
        carColor: [
            '#d23',
            '#27c',
            '#fb3',
            '#2c6',
            '#a3d',
            '#e84'
        ][Math.floor(Math.random() * 6)],
        phase: Math.random() * Math.PI * 2
    };
}
// =====================================================================
//  COORDINATE HELPERS
//  depth -> screenY. Things at depth==worldScroll are at the bottom
//  (near camera); larger depth = higher up the screen (farther).
// =====================================================================
const $0dc60fbaf0564b4f$var$DEPTH_TO_PX = 1.0; // 1 world-depth unit ~ 1px vertically (tuned)
function $0dc60fbaf0564b4f$var$depthToScreenY(depth) {
    // when depth == worldScroll  -> bottom (GAME_HEIGHT)
    // increasing depth moves up the screen
    return $0dc60fbaf0564b4f$var$GAME_HEIGHT - (depth - $0dc60fbaf0564b4f$var$worldScroll) * $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
}
// =====================================================================
//  DRAWING — WORLD / GROUND BANDS (sheared parallelograms)
// =====================================================================
function $0dc60fbaf0564b4f$var$drawGround() {
    // Sky / backdrop at the very top
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#7ec0ee';
    $0dc60fbaf0564b4f$var$ctx.fillRect(0, 0, $0dc60fbaf0564b4f$var$GAME_WIDTH, $0dc60fbaf0564b4f$var$GAME_HEIGHT);
    // Build the receding ground as a stack of horizontal slices; for each
    // screen row we compute the sheared world-x boundaries and paint the
    // lawn / sidewalk / street segments. Doing it per-slice gives smooth
    // diagonal edges (the oblique look) without per-pixel cost.
    const SLICE = 4;
    for(let sy = 0; sy < $0dc60fbaf0564b4f$var$GAME_HEIGHT; sy += SLICE){
        const yMid = sy + SLICE / 2;
        const depthFactor = ($0dc60fbaf0564b4f$var$GAME_HEIGHT - yMid) / $0dc60fbaf0564b4f$var$GAME_HEIGHT; // 0 bottom .. 1 top
        // horizontal screen positions of each world boundary at this row
        const xLeftLawnL = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$LEFT_LAWN_X, yMid);
        const xWalkL = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$LEFT_WALK_X, yMid);
        const xStreetL = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$STREET_L_X, yMid);
        const xStreetR = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$STREET_R_X, yMid);
        const xWalkR = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$RIGHT_WALK_X, yMid);
        const xRightLawnR = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$RIGHT_LAWN_X, yMid);
        // Lawn (slightly darker as it recedes for depth)
        const lawnShade = 90 + Math.floor(60 * (1 - depthFactor));
        const lawn = 'rgb(' + Math.floor(lawnShade * 0.45) + ',' + (lawnShade + 40) + ',' + Math.floor(lawnShade * 0.42) + ')';
        $0dc60fbaf0564b4f$var$ctx.fillStyle = lawn;
        // full row as lawn first (covers far left/right beyond playfield)
        $0dc60fbaf0564b4f$var$ctx.fillRect(0, sy, $0dc60fbaf0564b4f$var$GAME_WIDTH, SLICE);
        // Left sidewalk
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#c9c4b4';
        $0dc60fbaf0564b4f$var$ctx.fillRect(xWalkL, sy, xStreetL - xWalkL, SLICE);
        // Right sidewalk
        $0dc60fbaf0564b4f$var$ctx.fillRect(xWalkR, sy, xRightLawnR - xWalkR + 0, SLICE);
        // (right sidewalk drawn to RIGHT_LAWN boundary; lawn beyond repainted next row band)
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#c9c4b4';
        $0dc60fbaf0564b4f$var$ctx.fillRect(xWalkR, sy, xRightLawnR - xWalkR, SLICE);
        // Street
        const streetShade = 70 + Math.floor(30 * (1 - depthFactor));
        $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgb(' + streetShade + ',' + streetShade + ',' + (streetShade + 6) + ')';
        $0dc60fbaf0564b4f$var$ctx.fillRect(xStreetL, sy, xStreetR - xStreetL, SLICE);
    // Re-cover far right lawn (street drawing may have over-extended none, safe)
    }
    // Sidewalk seams (kerbs) and center dashes drawn as sheared lines
    $0dc60fbaf0564b4f$var$drawGroundLines();
}
function $0dc60fbaf0564b4f$var$drawGroundLines() {
    // Kerb lines between street and sidewalks
    $0dc60fbaf0564b4f$var$ctx.lineWidth = 2;
    $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#9a9486';
    $0dc60fbaf0564b4f$var$drawWorldVLine($0dc60fbaf0564b4f$var$STREET_L_X);
    $0dc60fbaf0564b4f$var$drawWorldVLine($0dc60fbaf0564b4f$var$STREET_R_X);
    $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#b8b2a2';
    $0dc60fbaf0564b4f$var$drawWorldVLine($0dc60fbaf0564b4f$var$LEFT_WALK_X);
    $0dc60fbaf0564b4f$var$drawWorldVLine($0dc60fbaf0564b4f$var$RIGHT_WALK_X);
    // Dashed center line of the street, scrolling toward camera.
    const centerX = ($0dc60fbaf0564b4f$var$STREET_L_X + $0dc60fbaf0564b4f$var$STREET_R_X) / 2;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#e8d24a';
    const dashWorld = 60;
    const phase = $0dc60fbaf0564b4f$var$worldScroll % dashWorld;
    for(let d = -phase; d < $0dc60fbaf0564b4f$var$GAME_HEIGHT / $0dc60fbaf0564b4f$var$DEPTH_TO_PX + dashWorld; d += dashWorld){
        const depth = $0dc60fbaf0564b4f$var$worldScroll + d;
        const yTop = $0dc60fbaf0564b4f$var$depthToScreenY(depth + 26);
        const yBot = $0dc60fbaf0564b4f$var$depthToScreenY(depth);
        if (yBot < -20 || yTop > $0dc60fbaf0564b4f$var$GAME_HEIGHT + 20) continue;
        const xTop = $0dc60fbaf0564b4f$var$worldToScreenX(centerX, yTop);
        const xBot = $0dc60fbaf0564b4f$var$worldToScreenX(centerX, yBot);
        $0dc60fbaf0564b4f$var$ctx.beginPath();
        $0dc60fbaf0564b4f$var$ctx.moveTo(xTop - 3, yTop);
        $0dc60fbaf0564b4f$var$ctx.lineTo(xTop + 3, yTop);
        $0dc60fbaf0564b4f$var$ctx.lineTo(xBot + 4, yBot);
        $0dc60fbaf0564b4f$var$ctx.lineTo(xBot - 4, yBot);
        $0dc60fbaf0564b4f$var$ctx.closePath();
        $0dc60fbaf0564b4f$var$ctx.fill();
    }
}
// Draw a vertical-in-world line across the whole screen (sheared).
function $0dc60fbaf0564b4f$var$drawWorldVLine(wx) {
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    let first = true;
    for(let sy = 0; sy <= $0dc60fbaf0564b4f$var$GAME_HEIGHT; sy += 8){
        const x = $0dc60fbaf0564b4f$var$worldToScreenX(wx, sy);
        if (first) {
            $0dc60fbaf0564b4f$var$ctx.moveTo(x, sy);
            first = false;
        } else $0dc60fbaf0564b4f$var$ctx.lineTo(x, sy);
    }
    $0dc60fbaf0564b4f$var$ctx.stroke();
}
// =====================================================================
//  DRAWING — HOUSES (oblique projection)
// =====================================================================
function $0dc60fbaf0564b4f$var$drawHouse(h) {
    const screenY = $0dc60fbaf0564b4f$var$depthToScreenY(h.depth);
    if (screenY < -200 || screenY > $0dc60fbaf0564b4f$var$GAME_HEIGHT + 200) return;
    // Anchor: front-bottom-left corner of the house in screen space.
    const baseX = $0dc60fbaf0564b4f$var$worldToScreenX(h.wx, screenY);
    // Scale a touch by depth so distant houses are a little smaller.
    const depthF = Math.max(0.6, Math.min(1.15, ($0dc60fbaf0564b4f$var$GAME_HEIGHT - screenY) / $0dc60fbaf0564b4f$var$GAME_HEIGHT * 0.7 + 0.65));
    const W = h.width * depthF; // front face width
    const H = 64 * depthF; // wall height
    const D = 30 * depthF; // oblique depth (side face)
    const dx = h.side === 'left' ? -1 : 1; // which way the side face extends
    // For oblique we offset back-and-up. Side face goes "into" the screen:
    const ox = D * 0.9 * (h.side === 'left' ? 1 : -1);
    const oy = -D * 0.8;
    const x = baseX;
    const yBottom = screenY;
    const yTop = screenY - H;
    const pal = h.pal;
    // ---- side face (drawn first, behind front) ----
    $0dc60fbaf0564b4f$var$ctx.fillStyle = $0dc60fbaf0564b4f$var$shade(pal.wall2, h.flash > 0 ? 1.25 : 1);
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    if (h.side === 'left') {
        // side face on the right of the front face
        $0dc60fbaf0564b4f$var$ctx.moveTo(x + W, yBottom);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x + W + ox, yBottom + oy);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x + W + ox, yTop + oy);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x + W, yTop);
    } else {
        $0dc60fbaf0564b4f$var$ctx.moveTo(x, yBottom);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x + ox, yBottom + oy);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x + ox, yTop + oy);
        $0dc60fbaf0564b4f$var$ctx.lineTo(x, yTop);
    }
    $0dc60fbaf0564b4f$var$ctx.closePath();
    $0dc60fbaf0564b4f$var$ctx.fill();
    // ---- front face ----
    $0dc60fbaf0564b4f$var$ctx.fillStyle = $0dc60fbaf0564b4f$var$shade(pal.wall, h.flash > 0 ? 1.2 : 1);
    $0dc60fbaf0564b4f$var$ctx.fillRect(x, yTop, W, H);
    // ---- roof (pitched) ----
    // Front gable triangle + sloped top to the back.
    const ridge = 26 * depthF;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = pal.roof;
    // top slab over front+side
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    $0dc60fbaf0564b4f$var$ctx.moveTo(x, yTop);
    $0dc60fbaf0564b4f$var$ctx.lineTo(x + W, yTop);
    $0dc60fbaf0564b4f$var$ctx.lineTo(x + W + ox, yTop + oy);
    $0dc60fbaf0564b4f$var$ctx.lineTo(x + ox, yTop + oy);
    $0dc60fbaf0564b4f$var$ctx.closePath();
    $0dc60fbaf0564b4f$var$ctx.fill();
    // front gable
    $0dc60fbaf0564b4f$var$ctx.fillStyle = $0dc60fbaf0564b4f$var$shade(pal.roof, 1.15);
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    $0dc60fbaf0564b4f$var$ctx.moveTo(x, yTop);
    $0dc60fbaf0564b4f$var$ctx.lineTo(x + W, yTop);
    $0dc60fbaf0564b4f$var$ctx.lineTo(x + W / 2, yTop - ridge);
    $0dc60fbaf0564b4f$var$ctx.closePath();
    $0dc60fbaf0564b4f$var$ctx.fill();
    // ---- door ----
    const doorW = W * 0.26, doorH = H * 0.5;
    const doorX = x + W * 0.37, doorY = yBottom - doorH;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = pal.door;
    $0dc60fbaf0564b4f$var$ctx.fillRect(doorX, doorY, doorW, doorH);
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#ffd23f';
    $0dc60fbaf0564b4f$var$ctx.fillRect(doorX + doorW - 4 * depthF, doorY + doorH * 0.5, 2 * depthF, 2 * depthF);
    // ---- windows ----
    const winW = W * 0.2, winH = H * 0.24;
    const w1x = x + W * 0.1, w2x = x + W * 0.68, wy = yTop + H * 0.22;
    $0dc60fbaf0564b4f$var$drawWindow(w1x, wy, winW, winH, h, 1);
    $0dc60fbaf0564b4f$var$drawWindow(w2x, wy, winW, winH, h, 2);
    if (h.isSubscriber) {
        // ---- mailbox out front (target) ----
        const mbX = h.side === 'left' ? x + W + 10 * depthF : x - 16 * depthF;
        const mbY = yBottom - 22 * depthF;
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#7a4a2a';
        $0dc60fbaf0564b4f$var$ctx.fillRect(mbX + 4 * depthF, mbY + 10 * depthF, 3 * depthF, 14 * depthF); // post
        $0dc60fbaf0564b4f$var$ctx.fillStyle = h.delivered ? '#36d66a' : '#d23b3b';
        $0dc60fbaf0564b4f$var$ctx.fillRect(mbX, mbY, 14 * depthF, 10 * depthF); // box
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#ffd23f';
        $0dc60fbaf0564b4f$var$ctx.fillRect(mbX + 12 * depthF, mbY + 1 * depthF, 2 * depthF, 5 * depthF); // flag
        // ---- doormat / porch target ----
        const matX = doorX - 2 * depthF, matY = yBottom - 3 * depthF;
        $0dc60fbaf0564b4f$var$ctx.fillStyle = h.delivered ? '#36d66a' : '#b98a5a';
        $0dc60fbaf0564b4f$var$ctx.fillRect(matX, matY, doorW + 6 * depthF, 4 * depthF);
        if (h.delivered) $0dc60fbaf0564b4f$var$pixTextCentered('OK', x + W / 2, yTop - ridge - 16, 2, '#36d66a');
    } else // Non-subscriber: subtle "no" marker so the player knows to smash.
    if (h.window1 && h.window2) $0dc60fbaf0564b4f$var$pixTextCentered('SMASH', x + W / 2, yTop - ridge - 16, 2, '#ff5b5b');
}
function $0dc60fbaf0564b4f$var$drawWindow(wx, wy, ww, wh, h, idx) {
    const smashed = idx === 1 ? h.window1 : h.window2;
    if (h.isSubscriber) {
        // subscriber windows are NOT targets; show hit (bad) as cracked red
        if (h.subWindowHit) {
            $0dc60fbaf0564b4f$var$ctx.fillStyle = '#3a3a3a';
            $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww, wh);
            $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#ff5b5b';
            $0dc60fbaf0564b4f$var$ctx.lineWidth = 1;
            $0dc60fbaf0564b4f$var$ctx.beginPath();
            $0dc60fbaf0564b4f$var$ctx.moveTo(wx, wy);
            $0dc60fbaf0564b4f$var$ctx.lineTo(wx + ww, wy + wh);
            $0dc60fbaf0564b4f$var$ctx.moveTo(wx + ww, wy);
            $0dc60fbaf0564b4f$var$ctx.lineTo(wx, wy + wh);
            $0dc60fbaf0564b4f$var$ctx.stroke();
        } else {
            $0dc60fbaf0564b4f$var$ctx.fillStyle = '#bfe6ff';
            $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww, wh);
            $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(255,255,255,0.5)';
            $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww * 0.45, wh * 0.45);
        }
    } else if (smashed) {
        // shattered: dark hole + jagged glass
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#1c1c22';
        $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww, wh);
        $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#bfe6ff';
        $0dc60fbaf0564b4f$var$ctx.lineWidth = 1;
        $0dc60fbaf0564b4f$var$ctx.beginPath();
        $0dc60fbaf0564b4f$var$ctx.moveTo(wx, wy + wh * 0.3);
        $0dc60fbaf0564b4f$var$ctx.lineTo(wx + ww * 0.4, wy + wh * 0.6);
        $0dc60fbaf0564b4f$var$ctx.lineTo(wx + ww * 0.2, wy + wh);
        $0dc60fbaf0564b4f$var$ctx.moveTo(wx + ww, wy);
        $0dc60fbaf0564b4f$var$ctx.lineTo(wx + ww * 0.6, wy + wh * 0.5);
        $0dc60fbaf0564b4f$var$ctx.stroke();
    } else {
        $0dc60fbaf0564b4f$var$ctx.fillStyle = '#bfe6ff';
        $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww, wh);
        $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(255,255,255,0.5)';
        $0dc60fbaf0564b4f$var$ctx.fillRect(wx, wy, ww * 0.45, wh * 0.45);
    }
    // frame
    $0dc60fbaf0564b4f$var$ctx.strokeStyle = 'rgba(0,0,0,0.4)';
    $0dc60fbaf0564b4f$var$ctx.lineWidth = 1;
    $0dc60fbaf0564b4f$var$ctx.strokeRect(wx, wy, ww, wh);
}
// brighten/darken a hex color by factor
function $0dc60fbaf0564b4f$var$shade(hex, f) {
    if (f === 1) return hex;
    const n = parseInt(hex.slice(1), 16);
    let r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
    r = Math.min(255, Math.floor(r * f));
    g = Math.min(255, Math.floor(g * f));
    b = Math.min(255, Math.floor(b * f));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}
// =====================================================================
//  DRAWING — ENTITIES / BUNDLES / PAPERS / PLAYER
// =====================================================================
function $0dc60fbaf0564b4f$var$drawEntity(e) {
    const screenY = $0dc60fbaf0564b4f$var$depthToScreenY(e.depth);
    if (screenY < -60 || screenY > $0dc60fbaf0564b4f$var$GAME_HEIGHT + 60) return;
    const sx = $0dc60fbaf0564b4f$var$worldToScreenX(e.wx, screenY);
    const depthF = Math.max(0.7, Math.min(1.2, ($0dc60fbaf0564b4f$var$GAME_HEIGHT - screenY) / $0dc60fbaf0564b4f$var$GAME_HEIGHT * 0.6 + 0.7));
    const scale = depthF * 2;
    // shadow
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.18)';
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    $0dc60fbaf0564b4f$var$ctx.ellipse(sx, screenY + 2, e.w * scale * 0.45, 4 * depthF, 0, 0, Math.PI * 2);
    $0dc60fbaf0564b4f$var$ctx.fill();
    if (e.type === 'car') {
        $0dc60fbaf0564b4f$var$drawCar(e, sx, screenY, scale);
        return;
    }
    if (e.sprite) {
        const ox = sx - e.sprite.w * scale / 2;
        const oy = screenY - e.sprite.h * scale;
        const flip = e.vx < 0;
        $0dc60fbaf0564b4f$var$drawSprite(e.sprite, ox, oy, scale, flip);
    }
}
function $0dc60fbaf0564b4f$var$drawCar(e, sx, sy, scale) {
    const w = 36 * scale * 0.5, h = 22 * scale * 0.5;
    const x = sx - w / 2, y = sy - h;
    // body
    $0dc60fbaf0564b4f$var$ctx.fillStyle = e.carColor;
    $0dc60fbaf0564b4f$var$ctx.fillRect(x, y, w, h);
    // roof/cabin
    $0dc60fbaf0564b4f$var$ctx.fillStyle = $0dc60fbaf0564b4f$var$shade(e.carColor, 0.8);
    $0dc60fbaf0564b4f$var$ctx.fillRect(x + w * 0.18, y - h * 0.4, w * 0.64, h * 0.45);
    // windows
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#bfe6ff';
    $0dc60fbaf0564b4f$var$ctx.fillRect(x + w * 0.22, y - h * 0.32, w * 0.24, h * 0.32);
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#bfe6ff';
    $0dc60fbaf0564b4f$var$ctx.fillRect(x + w * 0.54, y - h * 0.32, w * 0.24, h * 0.32);
    // wheels
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#1a1a1a';
    $0dc60fbaf0564b4f$var$ctx.fillRect(x + w * 0.1, y + h - 2, w * 0.22, 4 * scale * 0.5);
    $0dc60fbaf0564b4f$var$ctx.fillRect(x + w * 0.68, y + h - 2, w * 0.22, 4 * scale * 0.5);
    // headlight
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#fff3a0';
    $0dc60fbaf0564b4f$var$ctx.fillRect(e.vd >= 0 ? x + w - 3 : x, y + h * 0.3, 3, 4);
}
function $0dc60fbaf0564b4f$var$drawBundle(b) {
    if (b.collected) return;
    const screenY = $0dc60fbaf0564b4f$var$depthToScreenY(b.depth);
    if (screenY < -40 || screenY > $0dc60fbaf0564b4f$var$GAME_HEIGHT + 40) return;
    const sx = $0dc60fbaf0564b4f$var$worldToScreenX(b.wx, screenY);
    const depthF = Math.max(0.7, Math.min(1.2, ($0dc60fbaf0564b4f$var$GAME_HEIGHT - screenY) / $0dc60fbaf0564b4f$var$GAME_HEIGHT * 0.6 + 0.7));
    const scale = depthF * 2;
    // bob
    const bob = $0dc60fbaf0564b4f$var$prefersReducedMotion ? 0 : Math.sin(Date.now() / 200 + b.depth) * 2;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.18)';
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    $0dc60fbaf0564b4f$var$ctx.ellipse(sx, screenY + 2, 10 * depthF, 3 * depthF, 0, 0, Math.PI * 2);
    $0dc60fbaf0564b4f$var$ctx.fill();
    $0dc60fbaf0564b4f$var$drawSprite($0dc60fbaf0564b4f$var$SPR_BUNDLE, sx - $0dc60fbaf0564b4f$var$SPR_BUNDLE.w * scale / 2, screenY - $0dc60fbaf0564b4f$var$SPR_BUNDLE.h * scale + bob, scale, false);
}
function $0dc60fbaf0564b4f$var$drawFlyingPaper(p) {
    // paper has its own depth too (so it scrolls with the world)
    const screenY = $0dc60fbaf0564b4f$var$depthToScreenY(p.depth) - p.lift;
    const sx = $0dc60fbaf0564b4f$var$worldToScreenX(p.wx, $0dc60fbaf0564b4f$var$depthToScreenY(p.depth)) + 0;
    $0dc60fbaf0564b4f$var$ctx.save();
    $0dc60fbaf0564b4f$var$ctx.translate(sx, screenY);
    $0dc60fbaf0564b4f$var$ctx.rotate(p.rot);
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#f4f4f4';
    $0dc60fbaf0564b4f$var$ctx.fillRect(-6, -4, 12, 8);
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#bbb';
    $0dc60fbaf0564b4f$var$ctx.fillRect(-6, -4, 12, 2);
    $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#333';
    $0dc60fbaf0564b4f$var$ctx.lineWidth = 1;
    $0dc60fbaf0564b4f$var$ctx.strokeRect(-6, -4, 12, 8);
    $0dc60fbaf0564b4f$var$ctx.restore();
}
function $0dc60fbaf0564b4f$var$drawParticles() {
    for (const pt of $0dc60fbaf0564b4f$var$particles){
        $0dc60fbaf0564b4f$var$ctx.globalAlpha = Math.max(0, pt.life / pt.maxLife);
        $0dc60fbaf0564b4f$var$ctx.fillStyle = pt.color;
        $0dc60fbaf0564b4f$var$ctx.fillRect(pt.x, pt.y, pt.size, pt.size);
    }
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = 1;
}
function $0dc60fbaf0564b4f$var$drawPlayer() {
    const screenY = $0dc60fbaf0564b4f$var$player.screenY;
    const sx = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$player.x, screenY);
    if ($0dc60fbaf0564b4f$var$gameState === 'crashing') {
        // tumble: spin the crash sprite
        $0dc60fbaf0564b4f$var$ctx.save();
        $0dc60fbaf0564b4f$var$ctx.translate(sx, screenY - 14);
        if (!$0dc60fbaf0564b4f$var$prefersReducedMotion) $0dc60fbaf0564b4f$var$ctx.rotate((1 - $0dc60fbaf0564b4f$var$crashTimer / 60) * Math.PI * 3);
        $0dc60fbaf0564b4f$var$drawSprite($0dc60fbaf0564b4f$var$SPR_PLAYER_CRASH, -$0dc60fbaf0564b4f$var$SPR_PLAYER_CRASH.w, -$0dc60fbaf0564b4f$var$SPR_PLAYER_CRASH.h, 2, false);
        $0dc60fbaf0564b4f$var$ctx.restore();
        return;
    }
    // invincible flashing (calmed under reduced motion)
    let alpha = 1;
    if ($0dc60fbaf0564b4f$var$player.invincible) {
        if ($0dc60fbaf0564b4f$var$prefersReducedMotion) alpha = 0.55;
        else if (Math.floor(Date.now() / 100) % 2 === 0) return;
    }
    // shadow
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.25)';
    $0dc60fbaf0564b4f$var$ctx.beginPath();
    $0dc60fbaf0564b4f$var$ctx.ellipse(sx, screenY + 2, 18, 5, 0, 0, Math.PI * 2);
    $0dc60fbaf0564b4f$var$ctx.fill();
    $0dc60fbaf0564b4f$var$ctx.save();
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = alpha;
    $0dc60fbaf0564b4f$var$ctx.translate(sx, screenY);
    // lean when steering
    $0dc60fbaf0564b4f$var$ctx.rotate($0dc60fbaf0564b4f$var$player.lean * 0.18);
    const spr = $0dc60fbaf0564b4f$var$SPR_PLAYER[$0dc60fbaf0564b4f$var$pedalFrame];
    $0dc60fbaf0564b4f$var$drawSprite(spr, -spr.w, -spr.h * 2 + 4, 2, false);
    $0dc60fbaf0564b4f$var$ctx.restore();
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = 1;
}
// =====================================================================
//  PARTICLES
// =====================================================================
function $0dc60fbaf0564b4f$var$spawnParticles(x, y, color, count, spread) {
    if ($0dc60fbaf0564b4f$var$prefersReducedMotion) count = Math.min(count, 4);
    for(let i = 0; i < count; i++)$0dc60fbaf0564b4f$var$particles.push({
        x: x,
        y: y,
        vx: (Math.random() - 0.5) * (spread || 4),
        vy: (Math.random() - 0.5) * (spread || 4) - 1,
        size: 2 + Math.random() * 2,
        color: color,
        life: 30,
        maxLife: 30
    });
}
function $0dc60fbaf0564b4f$var$updateParticles() {
    for(let i = $0dc60fbaf0564b4f$var$particles.length - 1; i >= 0; i--){
        const p = $0dc60fbaf0564b4f$var$particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.2;
        p.life--;
        if (p.life <= 0) $0dc60fbaf0564b4f$var$particles.splice(i, 1);
    }
}
// =====================================================================
//  THROWING + DELIVERY
//  A thrown paper gets a world depth (= where the rider is) plus a 'lift'
//  arc. It travels sideways in world-x and slightly forward in depth so
//  it reaches the houses. We test it against mailbox/porch/window hit
//  rectangles each frame.
// =====================================================================
function $0dc60fbaf0564b4f$var$throwPaper(dir) {
    if ($0dc60fbaf0564b4f$var$papers <= 0) {
        $0dc60fbaf0564b4f$var$sfxBadHit();
        $0dc60fbaf0564b4f$var$flashMessage('OUT OF PAPERS');
        return;
    }
    $0dc60fbaf0564b4f$var$papers--;
    $0dc60fbaf0564b4f$var$updateHUD();
    $0dc60fbaf0564b4f$var$sfxThrow();
    const playerDepth = $0dc60fbaf0564b4f$var$worldScroll + ($0dc60fbaf0564b4f$var$GAME_HEIGHT - $0dc60fbaf0564b4f$var$player.screenY) / $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
    $0dc60fbaf0564b4f$var$flyingPapers.push({
        wx: $0dc60fbaf0564b4f$var$player.x,
        depth: playerDepth,
        dir: dir,
        vx: dir === 'left' ? -7.5 : 7.5,
        vd: 3.2,
        lift: 0,
        vlift: 7.5,
        rot: 0,
        rotSpeed: dir === 'left' ? -0.4 : 0.4,
        life: 90,
        hit: false
    });
}
function $0dc60fbaf0564b4f$var$updateFlyingPapers() {
    for(let i = $0dc60fbaf0564b4f$var$flyingPapers.length - 1; i >= 0; i--){
        const p = $0dc60fbaf0564b4f$var$flyingPapers[i];
        p.wx += (p.dir === 'left' ? -1 : 1) * Math.abs(p.vx);
        p.depth += p.vd;
        p.lift += p.vlift;
        p.vlift -= 0.55; // gravity on the arc
        p.rot += p.rotSpeed;
        p.life--;
        // Off-world horizontally or expired
        if (p.life <= 0 || p.wx < -40 || p.wx > $0dc60fbaf0564b4f$var$WORLD_W + 40) {
            $0dc60fbaf0564b4f$var$flyingPapers.splice(i, 1);
            continue;
        }
        // Test against houses on the matching side.
        let consumed = false;
        for (const h of $0dc60fbaf0564b4f$var$houses){
            if (h.side === 'left' && p.dir !== 'left') continue;
            if (h.side === 'right' && p.dir !== 'right') continue;
            // depth proximity: paper must be near the house depth band
            const dDepth = Math.abs(p.depth - h.depth);
            if (dDepth > 90) continue;
            if (h.isSubscriber && !h.delivered) {
                // Target zone: a generous world-x window around the front
                // of the house (mailbox + porch). Tuned to feel fair.
                const targetMin = h.wx - 20;
                const targetMax = h.wx + h.width + 30;
                // Only a low throw lands on the porch/mailbox; a high-arcing
                // paper (lift > 30) falls through to the window-hit band
                // below, so smashing a subscriber's own window is reachable.
                if (p.wx >= targetMin && p.wx <= targetMax && p.lift <= 30 && dDepth < 70) {
                    // perfect if close to the doormat depth & center
                    const perfect = dDepth < 34;
                    h.delivered = true;
                    h.flash = 14;
                    $0dc60fbaf0564b4f$var$dayDelivered++;
                    $0dc60fbaf0564b4f$var$deliveryStreak++;
                    $0dc60fbaf0564b4f$var$bestStreak = Math.max($0dc60fbaf0564b4f$var$bestStreak, $0dc60fbaf0564b4f$var$deliveryStreak);
                    const streakBonus = Math.min(5, $0dc60fbaf0564b4f$var$deliveryStreak - 1) * 25;
                    $0dc60fbaf0564b4f$var$score += streakBonus;
                    if (perfect) {
                        $0dc60fbaf0564b4f$var$dayPerfectThrows++;
                        $0dc60fbaf0564b4f$var$score += 250;
                        $0dc60fbaf0564b4f$var$sfxPerfect();
                        $0dc60fbaf0564b4f$var$flashMessage('PERFECT!');
                    } else {
                        $0dc60fbaf0564b4f$var$score += 100;
                        $0dc60fbaf0564b4f$var$sfxDeliver();
                        $0dc60fbaf0564b4f$var$flashMessage('DELIVERED!');
                    }
                    if (streakBonus) $0dc60fbaf0564b4f$var$flashMessage(`${$0dc60fbaf0564b4f$var$deliveryStreak} IN A ROW! +${streakBonus}`);
                    $0dc60fbaf0564b4f$var$spawnParticles($0dc60fbaf0564b4f$var$worldToScreenX(h.wx + h.width / 2, $0dc60fbaf0564b4f$var$depthToScreenY(h.depth)), $0dc60fbaf0564b4f$var$depthToScreenY(h.depth) - 20, '#ffd23f', 10, 5);
                    $0dc60fbaf0564b4f$var$updateHUD();
                    consumed = true;
                    break;
                }
                // Hitting the subscriber's WINDOW (bad) — narrower upper band
                const winMin = h.wx + h.width * 0.05;
                const winMax = h.wx + h.width * 0.9;
                if (!h.delivered && p.wx >= winMin && p.wx <= winMax && p.lift > 30 && dDepth < 40) {
                    h.subWindowHit = true;
                    $0dc60fbaf0564b4f$var$deliveryStreak = 0;
                    h.flash = 14;
                    $0dc60fbaf0564b4f$var$score = Math.max(0, $0dc60fbaf0564b4f$var$score - 50);
                    $0dc60fbaf0564b4f$var$sfxBadHit();
                    $0dc60fbaf0564b4f$var$flashMessage('OOPS! WRONG WINDOW');
                    $0dc60fbaf0564b4f$var$spawnParticles($0dc60fbaf0564b4f$var$worldToScreenX(h.wx + h.width / 2, $0dc60fbaf0564b4f$var$depthToScreenY(h.depth)), $0dc60fbaf0564b4f$var$depthToScreenY(h.depth) - 30, '#bfe6ff', 8, 4);
                    $0dc60fbaf0564b4f$var$updateHUD();
                    consumed = true;
                    break;
                }
            } else if (!h.isSubscriber) {
                // Smash a window: aim high (lift) at the wall band.
                const winMin = h.wx + h.width * 0.0;
                const winMax = h.wx + h.width * 1.0;
                if (p.wx >= winMin && p.wx <= winMax && dDepth < 60) {
                    if (!h.window1) h.window1 = true;
                    else if (!h.window2) h.window2 = true;
                    else continue; // already fully smashed; let paper pass
                    h.flash = 14;
                    $0dc60fbaf0564b4f$var$dayWindowsSmashed++;
                    $0dc60fbaf0564b4f$var$score += 75;
                    $0dc60fbaf0564b4f$var$sfxSmash();
                    $0dc60fbaf0564b4f$var$spawnParticles($0dc60fbaf0564b4f$var$worldToScreenX(h.wx + h.width / 2, $0dc60fbaf0564b4f$var$depthToScreenY(h.depth)), $0dc60fbaf0564b4f$var$depthToScreenY(h.depth) - 28, '#bfe6ff', 12, 6);
                    $0dc60fbaf0564b4f$var$updateHUD();
                    consumed = true;
                    break;
                }
            }
        }
        if (consumed) $0dc60fbaf0564b4f$var$flyingPapers.splice(i, 1);
    }
}
// =====================================================================
//  UPDATE LOOP PIECES
// =====================================================================
function $0dc60fbaf0564b4f$var$updatePlayer(dt) {
    // Speed control (up/down)
    if ($0dc60fbaf0564b4f$var$keys['ArrowUp'] || $0dc60fbaf0564b4f$var$keys['w'] || $0dc60fbaf0564b4f$var$keys['W']) $0dc60fbaf0564b4f$var$player.speed = Math.min($0dc60fbaf0564b4f$var$player.speed + 0.08, $0dc60fbaf0564b4f$var$SPEED_MAX);
    else if ($0dc60fbaf0564b4f$var$keys['ArrowDown'] || $0dc60fbaf0564b4f$var$keys['s'] || $0dc60fbaf0564b4f$var$keys['S']) $0dc60fbaf0564b4f$var$player.speed = Math.max($0dc60fbaf0564b4f$var$player.speed - 0.1, $0dc60fbaf0564b4f$var$SPEED_MIN);
    else {
        // drift toward a comfortable cruise
        if ($0dc60fbaf0564b4f$var$player.speed > 3.2) $0dc60fbaf0564b4f$var$player.speed -= 0.02;
        else if ($0dc60fbaf0564b4f$var$player.speed < 3.0) $0dc60fbaf0564b4f$var$player.speed += 0.02;
    }
    // Steering (left/right) in world-x
    let steer = 0;
    if ($0dc60fbaf0564b4f$var$keys['ArrowLeft'] || $0dc60fbaf0564b4f$var$keys['a'] || $0dc60fbaf0564b4f$var$keys['A']) steer -= 1;
    if ($0dc60fbaf0564b4f$var$keys['ArrowRight'] || $0dc60fbaf0564b4f$var$keys['d'] || $0dc60fbaf0564b4f$var$keys['D']) steer += 1;
    $0dc60fbaf0564b4f$var$player.x += steer * 3.0;
    $0dc60fbaf0564b4f$var$player.x = Math.max($0dc60fbaf0564b4f$var$PLAYER_MIN_X, Math.min($0dc60fbaf0564b4f$var$PLAYER_MAX_X, $0dc60fbaf0564b4f$var$player.x));
    // Lean toward steer direction (smoothed)
    $0dc60fbaf0564b4f$var$player.targetLean = steer;
    $0dc60fbaf0564b4f$var$player.lean += ($0dc60fbaf0564b4f$var$player.targetLean - $0dc60fbaf0564b4f$var$player.lean) * 0.25;
    // Scroll world toward camera based on speed
    $0dc60fbaf0564b4f$var$worldScroll += $0dc60fbaf0564b4f$var$player.speed;
    // Pedaling animation tied to speed
    $0dc60fbaf0564b4f$var$pedalAcc += $0dc60fbaf0564b4f$var$player.speed;
    if ($0dc60fbaf0564b4f$var$pedalAcc > 14) {
        $0dc60fbaf0564b4f$var$pedalFrame = 1 - $0dc60fbaf0564b4f$var$pedalFrame;
        $0dc60fbaf0564b4f$var$pedalAcc = 0;
    }
    // Invincibility timer
    if ($0dc60fbaf0564b4f$var$player.invincible) {
        $0dc60fbaf0564b4f$var$player.invTimer--;
        if ($0dc60fbaf0564b4f$var$player.invTimer <= 0) $0dc60fbaf0564b4f$var$player.invincible = false;
    }
    // throw inputs (single-press handled via key reset)
    if ($0dc60fbaf0564b4f$var$keys[' '] === true) {
        $0dc60fbaf0564b4f$var$throwPaper('left');
        $0dc60fbaf0564b4f$var$keys[' '] = false;
    }
    if ($0dc60fbaf0564b4f$var$keys['Enter'] === true) {
        $0dc60fbaf0564b4f$var$throwPaper('right');
        $0dc60fbaf0564b4f$var$keys['Enter'] = false;
    }
    if ($0dc60fbaf0564b4f$var$keys['Shift'] === true) {
        $0dc60fbaf0564b4f$var$throwPaper('right');
        $0dc60fbaf0564b4f$var$keys['Shift'] = false;
    }
}
function $0dc60fbaf0564b4f$var$updateEntities() {
    const playerDepth = $0dc60fbaf0564b4f$var$worldScroll + ($0dc60fbaf0564b4f$var$GAME_HEIGHT - $0dc60fbaf0564b4f$var$player.screenY) / $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
    for (const e of $0dc60fbaf0564b4f$var$entities){
        // movement
        if (e.moving) {
            if (e.type === 'car') e.depth += e.vd * 3.0;
            else if (e.chase) {
                // dog chases the player's world-x when nearby in depth
                const near = Math.abs(e.depth - playerDepth) < 200;
                if (near) {
                    const dir = Math.sign($0dc60fbaf0564b4f$var$player.x - e.wx) || 0;
                    e.wx += dir * 0.9;
                    // also creep toward camera a bit
                    e.depth -= 0.4;
                }
                e.wx = Math.max($0dc60fbaf0564b4f$var$STREET_L_X - 30, Math.min($0dc60fbaf0564b4f$var$STREET_R_X + 30, e.wx));
            } else {
                e.wx += e.vx;
                if (e.wx < $0dc60fbaf0564b4f$var$STREET_L_X - 10 || e.wx > $0dc60fbaf0564b4f$var$STREET_R_X + 10) e.vx *= -1;
            }
        }
        // collision with player (only when not invincible / not crashing)
        if (!$0dc60fbaf0564b4f$var$player.invincible && $0dc60fbaf0564b4f$var$gameState === 'playing') {
            const dDepth = Math.abs(e.depth - playerDepth);
            const dX = Math.abs(e.wx - $0dc60fbaf0564b4f$var$player.x);
            if (dDepth < 22 && dX < 22) $0dc60fbaf0564b4f$var$crash();
        }
    }
}
function $0dc60fbaf0564b4f$var$updateBundles() {
    const playerDepth = $0dc60fbaf0564b4f$var$worldScroll + ($0dc60fbaf0564b4f$var$GAME_HEIGHT - $0dc60fbaf0564b4f$var$player.screenY) / $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
    for (const b of $0dc60fbaf0564b4f$var$bundles){
        if (b.collected) continue;
        const dDepth = Math.abs(b.depth - playerDepth);
        const dX = Math.abs(b.wx - $0dc60fbaf0564b4f$var$player.x);
        if (dDepth < 26 && dX < 26) {
            b.collected = true;
            $0dc60fbaf0564b4f$var$papers += 5;
            $0dc60fbaf0564b4f$var$score += 25;
            $0dc60fbaf0564b4f$var$sfxPickup();
            $0dc60fbaf0564b4f$var$spawnParticles($0dc60fbaf0564b4f$var$worldToScreenX(b.wx, $0dc60fbaf0564b4f$var$depthToScreenY(b.depth)), $0dc60fbaf0564b4f$var$depthToScreenY(b.depth) - 10, '#f4f4f4', 8, 4);
            $0dc60fbaf0564b4f$var$updateHUD();
        }
    }
}
function $0dc60fbaf0564b4f$var$updateHouseFlashes() {
    for (const h of $0dc60fbaf0564b4f$var$houses)if (h.flash > 0) h.flash--;
}
function $0dc60fbaf0564b4f$var$crash() {
    $0dc60fbaf0564b4f$var$deliveryStreak = 0;
    $0dc60fbaf0564b4f$var$gameState = 'crashing';
    $0dc60fbaf0564b4f$var$crashTimer = 60;
    $0dc60fbaf0564b4f$var$sfxCrash();
    const sx = $0dc60fbaf0564b4f$var$worldToScreenX($0dc60fbaf0564b4f$var$player.x, $0dc60fbaf0564b4f$var$player.screenY);
    $0dc60fbaf0564b4f$var$spawnParticles(sx, $0dc60fbaf0564b4f$var$player.screenY - 14, '#ffd23f', 14, 6);
    $0dc60fbaf0564b4f$var$spawnParticles(sx, $0dc60fbaf0564b4f$var$player.screenY - 14, '#fff', 10, 6);
}
function $0dc60fbaf0564b4f$var$recoverFromCrash() {
    $0dc60fbaf0564b4f$var$lives--;
    $0dc60fbaf0564b4f$var$updateHUD();
    if ($0dc60fbaf0564b4f$var$lives <= 0) {
        $0dc60fbaf0564b4f$var$endGame();
        return;
    }
    $0dc60fbaf0564b4f$var$player.invincible = true;
    $0dc60fbaf0564b4f$var$player.invTimer = 120;
    $0dc60fbaf0564b4f$var$player.speed = $0dc60fbaf0564b4f$var$SPEED_MIN;
    $0dc60fbaf0564b4f$var$gameState = 'playing';
}
// =====================================================================
//  DAY FLOW
// =====================================================================
function $0dc60fbaf0564b4f$var$checkDayComplete() {
    const playerDepth = $0dc60fbaf0564b4f$var$worldScroll + ($0dc60fbaf0564b4f$var$GAME_HEIGHT - $0dc60fbaf0564b4f$var$player.screenY) / $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
    if (playerDepth > $0dc60fbaf0564b4f$var$streetLength) $0dc60fbaf0564b4f$var$completeDay();
}
function $0dc60fbaf0564b4f$var$completeDay() {
    $0dc60fbaf0564b4f$var$gameState = 'dayComplete';
    $0dc60fbaf0564b4f$var$completedDays = $0dc60fbaf0564b4f$var$currentDay + 1;
    $0dc60fbaf0564b4f$var$sfxDayDone();
    $0dc60fbaf0564b4f$var$saveHighScore();
    // Subscriber accounting:
    // - subscribers whose paper we missed may cancel
    // - subscribers whose own window we smashed cancel
    let lost = 0;
    for (const h of $0dc60fbaf0564b4f$var$houses)if (h.isSubscriber && (!h.delivered || h.subWindowHit)) lost++;
    const perfectDay = $0dc60fbaf0564b4f$var$daySubsTotal > 0 && $0dc60fbaf0564b4f$var$dayDelivered === $0dc60fbaf0564b4f$var$daySubsTotal && lost === 0;
    let gained = 0;
    if (perfectDay && $0dc60fbaf0564b4f$var$subscribers > 0) gained = 1; // perfect day -> new subscriber moves in
    $0dc60fbaf0564b4f$var$subscribers = Math.max(0, $0dc60fbaf0564b4f$var$subscribers - lost + gained);
    // bonus scoring
    let bonus = $0dc60fbaf0564b4f$var$dayDelivered * 25 + $0dc60fbaf0564b4f$var$dayWindowsSmashed * 10;
    if (perfectDay) bonus += 500;
    $0dc60fbaf0564b4f$var$score += bonus;
    $0dc60fbaf0564b4f$var$updateHUD();
    $0dc60fbaf0564b4f$var$saveHighScore();
    $0dc60fbaf0564b4f$var$showDayCompleteScreen({
        lost: lost,
        gained: gained,
        perfectDay: perfectDay,
        bonus: bonus
    });
}
function $0dc60fbaf0564b4f$var$showDayCompleteScreen(info) {
    const isLastDay = $0dc60fbaf0564b4f$var$currentDay >= 6;
    const allLost = $0dc60fbaf0564b4f$var$subscribers <= 0;
    let subLine;
    if (allLost) subLine = 'You lost all your subscribers!';
    else if (info.gained > 0) subLine = 'PERFECT DAY! A new subscriber moved in! (+1)';
    else if (info.lost > 0) subLine = info.lost + ' subscriber' + (info.lost > 1 ? 's' : '') + ' cancelled.';
    else subLine = 'No subscribers lost. Keep it up!';
    $0dc60fbaf0564b4f$var$overlay.innerHTML = '<div class="overlay-title">' + $0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay] + ' Done!</div>' + '<div class="stats-grid">' + '<div class="stat-item"><span class="stat-label">Deliveries:</span>' + $0dc60fbaf0564b4f$var$info_dd() + '</div>' + '<div class="stat-item"><span class="stat-label">Windows Smashed:</span>' + $0dc60fbaf0564b4f$var$dayWindowsSmashed + '</div>' + '<div class="stat-item"><span class="stat-label">Perfect Throws:</span>' + $0dc60fbaf0564b4f$var$dayPerfectThrows + '</div>' + '<div class="stat-item"><span class="stat-label">Day Bonus:</span>+' + info.bonus + '</div>' + '<div class="stat-item"><span class="stat-label">Subscribers:</span>' + $0dc60fbaf0564b4f$var$subscribers + '</div>' + '<div class="stat-item"><span class="stat-label">Total Score:</span>' + $0dc60fbaf0564b4f$var$score + '</div>' + '</div>' + '<div class="overlay-text" style="color:#FFD700;">' + subLine + '</div>' + '<div class="overlay-text">' + (allLost ? 'The route is finished.' : isLastDay ? 'You survived the whole week!' : 'Get ready for ' + $0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay + 1] + '!') + '</div>' + '<button class="button" id="continueButton">' + (allLost || isLastDay ? 'See Results' : 'Next Day') + '</button>';
    $0dc60fbaf0564b4f$var$overlay.classList.remove('hidden');
    $0dc60fbaf0564b4f$var$updateMobileControlsVisibility();
    document.getElementById('continueButton').onclick = ()=>{
        if (allLost || isLastDay) $0dc60fbaf0564b4f$var$endGame();
        else $0dc60fbaf0564b4f$var$nextDay();
    };
}
function $0dc60fbaf0564b4f$var$info_dd() {
    return $0dc60fbaf0564b4f$var$dayDelivered + '/' + $0dc60fbaf0564b4f$var$daySubsTotal;
}
function $0dc60fbaf0564b4f$var$nextDay() {
    $0dc60fbaf0564b4f$var$currentDay++;
    $0dc60fbaf0564b4f$var$papers = Math.max(8, 12 - $0dc60fbaf0564b4f$var$currentDay); // a bit scarcer each day
    $0dc60fbaf0564b4f$var$player.x = 130;
    $0dc60fbaf0564b4f$var$player.speed = 3;
    $0dc60fbaf0564b4f$var$player.invincible = false;
    $0dc60fbaf0564b4f$var$player.invTimer = 0;
    $0dc60fbaf0564b4f$var$generateLevel();
    $0dc60fbaf0564b4f$var$updateHUD();
    $0dc60fbaf0564b4f$var$startDayBanner();
}
function $0dc60fbaf0564b4f$var$startDayBanner() {
    $0dc60fbaf0564b4f$var$overlay.classList.add('hidden');
    $0dc60fbaf0564b4f$var$updateMobileControlsVisibility();
    $0dc60fbaf0564b4f$var$gameState = 'banner';
    $0dc60fbaf0564b4f$var$bannerTimer = $0dc60fbaf0564b4f$var$prefersReducedMotion ? 60 : 110;
}
function $0dc60fbaf0564b4f$var$endGame() {
    $0dc60fbaf0564b4f$var$gameState = 'gameOver';
    $0dc60fbaf0564b4f$var$saveHighScore();
    const wonWeek = $0dc60fbaf0564b4f$var$completedDays === 7 && $0dc60fbaf0564b4f$var$subscribers > 0 && $0dc60fbaf0564b4f$var$lives > 0;
    let titleTxt, msg;
    if (wonWeek) {
        titleTxt = 'You Won The Week!';
        msg = 'You kept your route alive all 7 days. Legendary paperboy!';
    } else if ($0dc60fbaf0564b4f$var$subscribers <= 0) {
        titleTxt = 'Route Lost';
        msg = 'Every last subscriber cancelled. The paper let you go.';
    } else {
        titleTxt = 'Game Over';
        msg = 'You ran out of lives on ' + $0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay] + '.';
    }
    const newHigh = $0dc60fbaf0564b4f$var$score >= $0dc60fbaf0564b4f$var$highScore && $0dc60fbaf0564b4f$var$score > 0;
    $0dc60fbaf0564b4f$var$overlay.innerHTML = '<div class="overlay-title">' + titleTxt + '</div>' + '<div class="overlay-text">' + msg + '</div>' + '<div class="stats-grid">' + '<div class="stat-item"><span class="stat-label">Final Score:</span>' + $0dc60fbaf0564b4f$var$score + '</div>' + '<div class="stat-item"><span class="stat-label">High Score:</span>' + $0dc60fbaf0564b4f$var$highScore + '</div>' + '<div class="stat-item"><span class="stat-label">Days Done:</span>' + $0dc60fbaf0564b4f$var$completedDays + '/7</div>' + '<div class="stat-item"><span class="stat-label">Best streak:</span>' + $0dc60fbaf0564b4f$var$bestStreak + '</div>' + '</div>' + (newHigh ? '<div class="overlay-text" style="color:#FFD700;">NEW HIGH SCORE!</div>' : '') + '<button class="button" id="restartButton">Play Again</button>' + '<a href="../index.html" class="button red-btn">Back to Site</a>';
    $0dc60fbaf0564b4f$var$overlay.classList.remove('hidden');
    $0dc60fbaf0564b4f$var$updateMobileControlsVisibility();
    document.getElementById('restartButton').onclick = ()=>{
        $0dc60fbaf0564b4f$var$startNewGame();
    };
}
// =====================================================================
//  HUD + MESSAGES
// =====================================================================
function $0dc60fbaf0564b4f$var$updateHUD() {
    $0dc60fbaf0564b4f$var$saveHighScore();
    document.getElementById('score').textContent = $0dc60fbaf0564b4f$var$score;
    document.getElementById('papers').textContent = $0dc60fbaf0564b4f$var$papers;
    document.getElementById('lives').textContent = $0dc60fbaf0564b4f$var$lives;
    document.getElementById('day').textContent = $0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay];
    document.getElementById('subscribers').textContent = $0dc60fbaf0564b4f$var$subscribers;
}
function $0dc60fbaf0564b4f$var$flashMessage(txt) {
    $0dc60fbaf0564b4f$var$messageText = txt;
    $0dc60fbaf0564b4f$var$messageTimer = 70;
}
function $0dc60fbaf0564b4f$var$drawMessageBanner() {
    if ($0dc60fbaf0564b4f$var$messageTimer <= 0) return;
    $0dc60fbaf0564b4f$var$messageTimer--;
    const alpha = Math.min(1, $0dc60fbaf0564b4f$var$messageTimer / 20);
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = alpha;
    const w = $0dc60fbaf0564b4f$var$pixTextWidth($0dc60fbaf0564b4f$var$messageText, 3) + 24;
    const x = ($0dc60fbaf0564b4f$var$GAME_WIDTH - w) / 2;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.7)';
    $0dc60fbaf0564b4f$var$ctx.fillRect(x, 70, w, 36);
    $0dc60fbaf0564b4f$var$ctx.strokeStyle = '#ffd23f';
    $0dc60fbaf0564b4f$var$ctx.lineWidth = 2;
    $0dc60fbaf0564b4f$var$ctx.strokeRect(x, 70, w, 36);
    $0dc60fbaf0564b4f$var$pixTextCentered($0dc60fbaf0564b4f$var$messageText, $0dc60fbaf0564b4f$var$GAME_WIDTH / 2, 80, 3, '#ffd23f');
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = 1;
}
// In-canvas mini HUD strip (so it reads even on mobile where the DOM HUD is tiny)
function $0dc60fbaf0564b4f$var$drawCanvasHUD() {
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.55)';
    $0dc60fbaf0564b4f$var$ctx.fillRect(0, 0, $0dc60fbaf0564b4f$var$GAME_WIDTH, 30);
    let x = 12;
    x = $0dc60fbaf0564b4f$var$pixText('SCORE ' + $0dc60fbaf0564b4f$var$score, x, 8, 2, '#ffd23f') + 18;
    x = $0dc60fbaf0564b4f$var$pixText('PAPERS ' + $0dc60fbaf0564b4f$var$papers, x, 8, 2, '#fff') + 18;
    x = $0dc60fbaf0564b4f$var$pixText('SUBS ' + $0dc60fbaf0564b4f$var$subscribers, x, 8, 2, '#7fffa0') + 18;
    x = $0dc60fbaf0564b4f$var$pixText('LIVES ' + $0dc60fbaf0564b4f$var$lives, x, 8, 2, '#ff7b7b') + 18;
    // day on the right
    $0dc60fbaf0564b4f$var$pixText($0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay], $0dc60fbaf0564b4f$var$GAME_WIDTH - $0dc60fbaf0564b4f$var$pixTextWidth($0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay], 2) - 12, 8, 2, '#bfe6ff');
}
function $0dc60fbaf0564b4f$var$drawDayBanner() {
    // big day name slides/fades in center
    const t = $0dc60fbaf0564b4f$var$bannerTimer;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = 'rgba(0,0,0,0.45)';
    $0dc60fbaf0564b4f$var$ctx.fillRect(0, $0dc60fbaf0564b4f$var$GAME_HEIGHT / 2 - 60, $0dc60fbaf0564b4f$var$GAME_WIDTH, 120);
    $0dc60fbaf0564b4f$var$pixTextCentered($0dc60fbaf0564b4f$var$DAYS[$0dc60fbaf0564b4f$var$currentDay], $0dc60fbaf0564b4f$var$GAME_WIDTH / 2, $0dc60fbaf0564b4f$var$GAME_HEIGHT / 2 - 40, 6, '#ffd23f');
    const sub = $0dc60fbaf0564b4f$var$daySubsTotal + ' SUBSCRIBERS ON THE ROUTE';
    $0dc60fbaf0564b4f$var$pixTextCentered(sub, $0dc60fbaf0564b4f$var$GAME_WIDTH / 2, $0dc60fbaf0564b4f$var$GAME_HEIGHT / 2 + 14, 2, '#fff');
    if (!$0dc60fbaf0564b4f$var$prefersReducedMotion) // little arrow blink
    {
        if (Math.floor(t / 15) % 2 === 0) $0dc60fbaf0564b4f$var$pixTextCentered('GET READY', $0dc60fbaf0564b4f$var$GAME_WIDTH / 2, $0dc60fbaf0564b4f$var$GAME_HEIGHT / 2 + 38, 2, '#7fffa0');
    } else $0dc60fbaf0564b4f$var$pixTextCentered('GET READY', $0dc60fbaf0564b4f$var$GAME_WIDTH / 2, $0dc60fbaf0564b4f$var$GAME_HEIGHT / 2 + 38, 2, '#7fffa0');
}
// Optional subtle scanline/CRT overlay (respects reduced motion: static, faint)
function $0dc60fbaf0564b4f$var$drawScanlines() {
    if ($0dc60fbaf0564b4f$var$prefersReducedMotion) return;
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = 0.06;
    $0dc60fbaf0564b4f$var$ctx.fillStyle = '#000';
    for(let y = 0; y < $0dc60fbaf0564b4f$var$GAME_HEIGHT; y += 3)$0dc60fbaf0564b4f$var$ctx.fillRect(0, y, $0dc60fbaf0564b4f$var$GAME_WIDTH, 1);
    $0dc60fbaf0564b4f$var$ctx.globalAlpha = 1;
}
// =====================================================================
//  RENDER: draw world back-to-front so nearer things overlap farther.
// =====================================================================
function $0dc60fbaf0564b4f$var$render() {
    $0dc60fbaf0564b4f$var$drawGround();
    // Sort drawables by depth (far first => larger depth drawn first).
    // Houses, entities, bundles all carry a depth; flying papers too.
    const drawList = [];
    for (const h of $0dc60fbaf0564b4f$var$houses)drawList.push({
        depth: h.depth,
        kind: 'house',
        ref: h
    });
    for (const e of $0dc60fbaf0564b4f$var$entities)drawList.push({
        depth: e.depth,
        kind: 'entity',
        ref: e
    });
    for (const b of $0dc60fbaf0564b4f$var$bundles)if (!b.collected) drawList.push({
        depth: b.depth,
        kind: 'bundle',
        ref: b
    });
    $0dc60fbaf0564b4f$var$drawList_sortAndDraw(drawList);
    // Flying papers & particles on top
    for (const p of $0dc60fbaf0564b4f$var$flyingPapers)$0dc60fbaf0564b4f$var$drawFlyingPaper(p);
    $0dc60fbaf0564b4f$var$drawParticles();
    // Player (always near camera)
    $0dc60fbaf0564b4f$var$drawPlayer();
    // HUD overlays
    $0dc60fbaf0564b4f$var$drawCanvasHUD();
    $0dc60fbaf0564b4f$var$drawMessageBanner();
    if ($0dc60fbaf0564b4f$var$gameState === 'banner') $0dc60fbaf0564b4f$var$drawDayBanner();
    $0dc60fbaf0564b4f$var$drawScanlines();
}
function $0dc60fbaf0564b4f$var$drawList_sortAndDraw(list) {
    list.sort((a, b)=>b.depth - a.depth); // far (big depth) first
    for (const item of list){
        if (item.kind === 'house') $0dc60fbaf0564b4f$var$drawHouse(item.ref);
        else if (item.kind === 'entity') $0dc60fbaf0564b4f$var$drawEntity(item.ref);
        else if (item.kind === 'bundle') $0dc60fbaf0564b4f$var$drawBundle(item.ref);
    }
}
// =====================================================================
//  MAIN LOOP
// =====================================================================
// Fixed-timestep simulation. The game logic uses fixed per-frame deltas
// tuned for 60Hz, so we advance it in discrete 1/60s steps independent of
// the display refresh rate. Without this the whole game runs at 2x on a
// 120Hz ProMotion screen (the mobile target) and 3x at 144Hz. Rendering
// still happens once per animation frame.
const $0dc60fbaf0564b4f$var$SIM_STEP_MS = 1000 / 60;
const $0dc60fbaf0564b4f$var$MAX_STEPS_PER_FRAME = 5; // shed backlog after a long stall
let $0dc60fbaf0564b4f$var$lastTime = 0;
let $0dc60fbaf0564b4f$var$simAccumulator = 0;
function $0dc60fbaf0564b4f$var$stepSimulation() {
    if ($0dc60fbaf0564b4f$var$gameState === 'playing') {
        $0dc60fbaf0564b4f$var$updatePlayer();
        $0dc60fbaf0564b4f$var$updateEntities();
        $0dc60fbaf0564b4f$var$updateBundles();
        $0dc60fbaf0564b4f$var$updateFlyingPapers();
        $0dc60fbaf0564b4f$var$updateHouseFlashes();
        $0dc60fbaf0564b4f$var$updateParticles();
        $0dc60fbaf0564b4f$var$updateRoute();
        $0dc60fbaf0564b4f$var$checkDayComplete();
    } else if ($0dc60fbaf0564b4f$var$gameState === 'crashing') {
        $0dc60fbaf0564b4f$var$crashTimer--;
        $0dc60fbaf0564b4f$var$updateParticles();
        // keep papers/entities gently moving for life
        $0dc60fbaf0564b4f$var$updateFlyingPapers();
        if ($0dc60fbaf0564b4f$var$crashTimer <= 0) $0dc60fbaf0564b4f$var$recoverFromCrash();
    } else if ($0dc60fbaf0564b4f$var$gameState === 'banner') {
        $0dc60fbaf0564b4f$var$bannerTimer--;
        $0dc60fbaf0564b4f$var$updateParticles();
        if ($0dc60fbaf0564b4f$var$bannerTimer <= 0) $0dc60fbaf0564b4f$var$gameState = 'playing';
    } else $0dc60fbaf0564b4f$var$updateParticles();
}
function $0dc60fbaf0564b4f$var$gameLoop(timestamp) {
    if (!$0dc60fbaf0564b4f$var$lastTime) $0dc60fbaf0564b4f$var$lastTime = timestamp;
    let frameMs = timestamp - $0dc60fbaf0564b4f$var$lastTime;
    $0dc60fbaf0564b4f$var$lastTime = timestamp;
    if (frameMs > 100) frameMs = 100; // clamp big gaps (tab switch)
    if ((0, $1FxTl.arcade).paused) {
        $0dc60fbaf0564b4f$var$simAccumulator = 0;
        requestAnimationFrame($0dc60fbaf0564b4f$var$gameLoop);
        return;
    }
    $0dc60fbaf0564b4f$var$simAccumulator += frameMs;
    let steps = 0;
    while($0dc60fbaf0564b4f$var$simAccumulator >= $0dc60fbaf0564b4f$var$SIM_STEP_MS && steps < $0dc60fbaf0564b4f$var$MAX_STEPS_PER_FRAME){
        $0dc60fbaf0564b4f$var$stepSimulation();
        $0dc60fbaf0564b4f$var$simAccumulator -= $0dc60fbaf0564b4f$var$SIM_STEP_MS;
        steps++;
    }
    if (steps >= $0dc60fbaf0564b4f$var$MAX_STEPS_PER_FRAME) $0dc60fbaf0564b4f$var$simAccumulator = 0;
    if ($0dc60fbaf0564b4f$var$gameState !== 'title') $0dc60fbaf0564b4f$var$updateRoute();
    $0dc60fbaf0564b4f$var$ctx.clearRect(0, 0, $0dc60fbaf0564b4f$var$GAME_WIDTH, $0dc60fbaf0564b4f$var$GAME_HEIGHT);
    if ($0dc60fbaf0564b4f$var$gameState === 'title') {
        // simple idle backdrop behind the overlay
        $0dc60fbaf0564b4f$var$drawGround();
        $0dc60fbaf0564b4f$var$drawCanvasHUD();
        $0dc60fbaf0564b4f$var$drawScanlines();
    } else $0dc60fbaf0564b4f$var$render();
    requestAnimationFrame($0dc60fbaf0564b4f$var$gameLoop);
}
// =====================================================================
//  GAME SETUP / RESET
// =====================================================================
function $0dc60fbaf0564b4f$var$updateRoute() {
    const depth = $0dc60fbaf0564b4f$var$worldScroll + ($0dc60fbaf0564b4f$var$GAME_HEIGHT - $0dc60fbaf0564b4f$var$player.screenY) / $0dc60fbaf0564b4f$var$DEPTH_TO_PX;
    for (const house of $0dc60fbaf0564b4f$var$houses)if (house.isSubscriber && !house.delivered && !house.missedHandled && house.depth < depth - 100) {
        house.missedHandled = true;
        $0dc60fbaf0564b4f$var$deliveryStreak = 0;
        $0dc60fbaf0564b4f$var$flashMessage('MISSED A SUBSCRIBER');
    }
    const next = $0dc60fbaf0564b4f$var$houses.filter((h)=>h.isSubscriber && !h.delivered && !h.missedHandled).sort((a, b)=>a.depth - b.depth)[0];
    const target = next ? `Next delivery: ${next.side}` : 'Deliveries done. Finish the route.';
    (0, $1FxTl.arcade).status(`${$0dc60fbaf0564b4f$var$dayDelivered}/${$0dc60fbaf0564b4f$var$daySubsTotal} delivered \xb7 ${target} \xb7 Streak ${$0dc60fbaf0564b4f$var$deliveryStreak} \xb7 Best ${$0dc60fbaf0564b4f$var$highScore.toLocaleString()}`, depth / $0dc60fbaf0564b4f$var$streetLength * 100);
}
function $0dc60fbaf0564b4f$var$startNewGame() {
    $0dc60fbaf0564b4f$var$initAudio();
    $0dc60fbaf0564b4f$var$resumeAudio();
    $0dc60fbaf0564b4f$var$score = 0;
    $0dc60fbaf0564b4f$var$lives = 3;
    $0dc60fbaf0564b4f$var$currentDay = 0;
    $0dc60fbaf0564b4f$var$completedDays = $0dc60fbaf0564b4f$var$bestStreak = $0dc60fbaf0564b4f$var$deliveryStreak = 0;
    $0dc60fbaf0564b4f$var$subscribers = 5;
    $0dc60fbaf0564b4f$var$papers = 12;
    $0dc60fbaf0564b4f$var$player.x = 130;
    $0dc60fbaf0564b4f$var$player.speed = 3;
    $0dc60fbaf0564b4f$var$player.lean = 0;
    $0dc60fbaf0564b4f$var$player.invincible = false;
    $0dc60fbaf0564b4f$var$player.invTimer = 0;
    $0dc60fbaf0564b4f$var$generateLevel();
    $0dc60fbaf0564b4f$var$updateHUD();
    $0dc60fbaf0564b4f$var$startDayBanner();
}
// =====================================================================
//  INPUT
// =====================================================================
const $0dc60fbaf0564b4f$var$GAME_KEYS = new Set([
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    ' ',
    'Enter',
    'Shift',
    'w',
    'W',
    'a',
    'A',
    's',
    'S',
    'd',
    'D'
]);
document.addEventListener('keydown', (e)=>{
    // Let keyboard users activate a focused overlay button/link (Start,
    // Continue, Restart, Back to Site) — don't swallow Enter/Space there.
    if (e.target && e.target.closest && e.target.closest('button, a')) return;
    // first interaction primes audio
    $0dc60fbaf0564b4f$var$initAudio();
    $0dc60fbaf0564b4f$var$resumeAudio();
    if ($0dc60fbaf0564b4f$var$GAME_KEYS.has(e.key)) {
        if (!e.repeat) $0dc60fbaf0564b4f$var$keys[e.key] = true;
        // Space/Enter/Shift are single-press: consumed in updatePlayer.
        e.preventDefault();
    }
});
document.addEventListener('keyup', (e)=>{
    if (e.target && e.target.closest && e.target.closest('button, a')) return;
    if ($0dc60fbaf0564b4f$var$GAME_KEYS.has(e.key)) {
        // Don't un-set the throw keys here; they're cleared on consume.
        if (e.key !== ' ' && e.key !== 'Enter' && e.key !== 'Shift') $0dc60fbaf0564b4f$var$keys[e.key] = false;
        e.preventDefault();
    }
});
$0dc60fbaf0564b4f$var$startButton.onclick = ()=>{
    $0dc60fbaf0564b4f$var$initAudio();
    $0dc60fbaf0564b4f$var$resumeAudio();
    $0dc60fbaf0564b4f$var$startNewGame();
};
// =====================================================================
//  MOBILE CONTROLS
// =====================================================================
const $0dc60fbaf0564b4f$var$btnUp = document.getElementById('btnUp');
const $0dc60fbaf0564b4f$var$btnDown = document.getElementById('btnDown');
const $0dc60fbaf0564b4f$var$btnLeft = document.getElementById('btnLeft');
const $0dc60fbaf0564b4f$var$btnRight = document.getElementById('btnRight');
const $0dc60fbaf0564b4f$var$btnThrowLeft = document.getElementById('btnThrowLeft');
const $0dc60fbaf0564b4f$var$btnThrowRight = document.getElementById('btnThrowRight');
// Continuous-press D-pad button
function $0dc60fbaf0564b4f$var$setupDpadButton(button, keyName) {
    const activate = (e)=>{
        e.preventDefault();
        $0dc60fbaf0564b4f$var$initAudio();
        $0dc60fbaf0564b4f$var$resumeAudio();
        $0dc60fbaf0564b4f$var$keys[keyName] = true;
        button.classList.add('active');
    };
    const deactivate = (e)=>{
        if (e) e.preventDefault();
        $0dc60fbaf0564b4f$var$keys[keyName] = false;
        button.classList.remove('active');
    };
    (0, $1FxTl.bindPointer)(button, ()=>activate({
            preventDefault () {}
        }), ()=>deactivate({
            preventDefault () {}
        }));
}
// Single-press action button (throw)
function $0dc60fbaf0564b4f$var$setupActionButton(button, keyName) {
    const activate = (e)=>{
        e.preventDefault();
        $0dc60fbaf0564b4f$var$initAudio();
        $0dc60fbaf0564b4f$var$resumeAudio();
        $0dc60fbaf0564b4f$var$keys[keyName] = true; // consumed next frame
        button.classList.add('active');
    };
    const deactivate = (e)=>{
        if (e) e.preventDefault();
        button.classList.remove('active');
    };
    (0, $1FxTl.bindPointer)(button, ()=>activate({
            preventDefault () {}
        }), ()=>deactivate({
            preventDefault () {}
        }));
}
$0dc60fbaf0564b4f$var$setupDpadButton($0dc60fbaf0564b4f$var$btnUp, 'ArrowUp');
$0dc60fbaf0564b4f$var$setupDpadButton($0dc60fbaf0564b4f$var$btnDown, 'ArrowDown');
$0dc60fbaf0564b4f$var$setupDpadButton($0dc60fbaf0564b4f$var$btnLeft, 'ArrowLeft');
$0dc60fbaf0564b4f$var$setupDpadButton($0dc60fbaf0564b4f$var$btnRight, 'ArrowRight');
$0dc60fbaf0564b4f$var$setupActionButton($0dc60fbaf0564b4f$var$btnThrowLeft, ' ');
$0dc60fbaf0564b4f$var$setupActionButton($0dc60fbaf0564b4f$var$btnThrowRight, 'Enter');
function $0dc60fbaf0564b4f$var$updateMobileControlsVisibility() {
    const mobileControls = document.getElementById('mobileControls');
    const dialogVisible = !$0dc60fbaf0564b4f$var$overlay.classList.contains('hidden');
    if (dialogVisible) mobileControls.classList.add('hidden');
    else mobileControls.classList.remove('hidden');
}
// Prevent scroll/zoom on the play area while playing
document.getElementById('gameContainer').addEventListener('touchmove', (e)=>{
    if ($0dc60fbaf0564b4f$var$gameState === 'playing' || $0dc60fbaf0564b4f$var$gameState === 'banner' || $0dc60fbaf0564b4f$var$gameState === 'crashing') e.preventDefault();
}, {
    passive: false
});
// =====================================================================
//  BOOT
// =====================================================================
(0, $1FxTl.arcade).mount({
    title: 'Paperboy',
    help: "W/\u2191 speeds up; S/\u2193 brakes; A/D or \u2190/\u2192 steers. Space throws left; Enter or Shift throws right. Start a throw before you pass a red mailbox. Link deliveries for streak bonuses. Collect paper bundles on the road. P pauses; M toggles sound.",
    active: ()=>[
            'playing',
            'banner',
            'crashing'
        ].includes($0dc60fbaf0564b4f$var$gameState),
    clearInput: ()=>Object.keys($0dc60fbaf0564b4f$var$keys).forEach((key)=>{
            $0dc60fbaf0564b4f$var$keys[key] = false;
        }),
    restart: $0dc60fbaf0564b4f$var$startNewGame,
    onResume: ()=>{
        $0dc60fbaf0564b4f$var$lastTime = performance.now();
        $0dc60fbaf0564b4f$var$simAccumulator = 0;
    }
});
(0, $1FxTl.arcade).status('Deliver to red mailboxes. Brake to line up a throw.');
$0dc60fbaf0564b4f$var$updateHUD();
$0dc60fbaf0564b4f$var$updateMobileControlsVisibility();
requestAnimationFrame($0dc60fbaf0564b4f$var$gameLoop);


//# sourceMappingURL=paperboy.8858ac06.js.map
